import { ContactValue } from '../domain/component/select-contact-component.domain';

declare var require: any;

import {
  AccessLevel,
  Base64File,
  Customer,
  DocumentTag,
  User,
  AzureFileTagable,
  UserandPriviledges, PaymentPeriodType, NotNullable
} from '../domain/types.domain';
import {
  constants,
  INTERNAL_ACCESS_LEVEL,
  INTERNAL_EMAIL_DOMAINS,
  TIER1_ASSET_CATS,
  TIER2_ASSET_CATS,
  TIER3_ASSET_CATS,
  TIER4_ASSET_CATS,
} from '../const';
import {
  ApplicationApplicant, ApplicationApplicantVal,
} from '../domain/types.domain';
import { Moment } from 'moment';
import {
  Application, AssetFinanceProductType, DscrCalculatorInput,
  DscrCalculatorValue,
  LvrCalculatorInput,
  LvrCalculatorValue,
  RatecardDetails,
  SFAccountData,
  SFContactArrayData,
  SFContactData,
  SFOpportunityData,
  SalesforceSyncApplication
} from '../domain/application-service.domain';
import { ContractPricingDetails } from '../domain/docusign-service.domain';
import { AmlOfficerCandidate } from '../domain/aml-dashboard.domain';
import numeral from 'numeral';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { DriverLicenceDetails, DriverLicenceDetailsError, NextAccreditationNumber, SubmitAccreditationInput } from '../domain/accreditation-service.domain';
import { AssetTypeRateValue } from '../domain/component/asset-type-rate-component.domain';
import { PpsrAsset, PpsrData } from '../domain/ppsr-service.domain';
import { IncomeSelectionValue } from '../domain/component/income-component.domain';
import { DeviceType, PismoAccountingCategory, PismoAccountingRecord, PismoCardReIssueReason, PismoFlexControlBody, PismoFlexControlResponse, PismoGenericTransaction, PismoNormalizedTransaction, PismoPendingTransaction, PismoPhoneBody, PismoReportAccountsBalances, PismoReportDailyBalances, PismoServiceBusNetworkTransaction, PismoServiceBusPaymentTransaction, PismoTransaction, PismoTransactionProcessingCode, PismoTransactionTypeForOFX, PismoTransactionTypeIds, } from '../domain/pismo.domain';
import {
  Disbursement,
} from '../domain/component/ppsr-asset-component.domain';
import { SoleTraderValue } from '../domain/component/sole-trader-component.domain';
import { Address2ComponentValue } from '../domain/component/address2-component.domain';
import { DirectorValue, IndividualDirector } from '../domain/component/director-component.domain';
import { EntityGuarantor, IndividualGuarantor } from '../domain/component/guarantor-component.domain';
import { IndividualMember } from '../domain/component/member-component.domain';
import { IndividualPartner } from '../domain/component/partner-component.domain';
import { IndividualTrustee } from '../domain/component/trustee-component.domain';
import { PismoBankingTransaction } from '../domain/banking-service.domain';
import { parseJSON } from './json';
import moment from 'moment';
import { removeUnprintableChar } from './address';
import { CreditRuleEntity, CreditRuleIndividual, CreditRuleInput, CreditRuleItem, CreditRuleItemOutputType, CreditRuleObject, CreditRuleOperator, CreditorWatchReportData, EquifaxConsumerReportData, CreditorwatchExtraction, CreditorwatchAdverseItem, CreditorwatchAdverseItemSource, EquifaxConsumerExtraction, EquifaxFraudCheckReportData, EquifaxFraudCheckExtraction } from '../domain/credit.domain';
import { getPismoTransactionType, getTransactionCategory } from './pismo';
import { applicantOf, primaryEntityOf } from './application-details-utils';
import { commercialEntityRoleType, individualSignerRole } from './application-party-labels';
import { SearchableSelectItem, UserSelectionComponentEvent } from "../domain/selection.domain";


import { FormControl } from '@angular/forms';
import { UserSelectionValue } from '../domain/component/user-selection-component.domain';
import { EventEmitter } from '@angular/core';



// =================================
// === comparator
// =================================
export const compareMatch = (obj1: any, obj2: any): boolean => {
  if (obj1 === obj2) {
    return true;
  }
  return _.isEqual(obj1, obj2);
}

/**
 * A BSB or Australian account number is digits only, but OCR text and older saved bank details can
 * carry hyphens or spaces. Not truncated: a value still too long after stripping must fail validation.
 */
export const stripNonDigits = <T extends string | null | undefined>(value: T): T =>
  (typeof value === 'string' ? value.replace(/\D/g, '') : value) as T;

//////////////////////////

export type ValidEmailCheckFn = (email: string) => Observable<boolean>;

/////

export const shipmentDocumentTags = (): DocumentTag[] => {
  return [
    constants.documentTypes.proForma,
    constants.documentTypes.salesAgreement,
    constants.documentTypes.purchaseOrder,
    constants.documentTypes.freightBooking,
    constants.documentTypes.commercialInvoice,
    constants.documentTypes.TransportDocument
  ]
}


// ======================================
// ============ floorplan calculation
// ======================================

/* export const calculateFloorplanPrice = (
  isNew: boolean,
  purchasePrice: number, opt: {
  }): {
    purchasePrice: number,
    deposit: number,
    managementFee: number,
    ppsrRegistrationFee: number,
    amountFinanced: number,
  } => {

  const deposit = (purchasePrice * (dep / 100));
  const amountFinanced = ((1 - (dep / 100)) * purchasePrice);
  let managementFee = 0;

  const totalAmountFinanced = amountFinanced + managementFee ;
  console.log('**** internal calc', isNew, dep, deposit, managementFee, totalAmountFinanced);
  return {
    purchasePrice,
    deposit,
    managementFee,
    amountFinanced: totalAmountFinanced,
  }
} */

export const getSchedulePaymentsFrequency = (arg: string, date: string) => {

  const specificDate = moment(date);

  switch (arg) {
    case 'fortnightly': {
      return specificDate.add(15, 'days').format('YYYY-MM-DD');
    }
    case 'weekly': {
      return specificDate.add(1, 'weeks').format('YYYY-MM-DD');
    }
    case 'monthly': {
      return specificDate.add(1, 'months').format('YYYY-MM-DD');
    }
    case 'date': {
      return date;
    }

    default: {
      return date;
    }

  }


}

export const individualApplicants = (applicant: ApplicationApplicant) => {
  const r: (IndividualTrustee | IndividualMember | IndividualPartner | NotNullable<SoleTraderValue> | IndividualDirector)[] = [];
  if (applicant) {
    if (Array.isArray(applicant)) {
      for (const _applicant of (applicant ?? [])) {
        if (_applicant.type === 'Individual') {
          r.push(_applicant);
        } else if (_applicant.kind === 'Director') {
          r.push(_applicant);
        }
      }
    } else {
      if (applicant.kind === 'SoleTrader') {
        r.push(applicant);
      }
    }
  }
  return r;
}

export const isApplicationApplicantsSoleTrader = (applicantValues: ApplicationApplicant): applicantValues is SoleTraderValue => {
  if (applicantValues) {
    return (!Array.isArray(applicantValues) && applicantValues.kind === 'SoleTrader');
  }
  return false;
}

export const isApplicationApplicantIndividual = (app: ApplicationApplicantVal | null): app is (IndividualTrustee | IndividualPartner | IndividualMember | Exclude<SoleTraderValue, null> | Exclude<DirectorValue, null>[number]) => {
  if (app) {
    if (app.kind == 'SoleTrader') {
      return true;
    } else if (app.kind == 'Director') {
      return true;
    } else {
      if (app.type == 'Individual') {
        return true;
      }
    }
  }
  return false;
}

export const isIndividualGrantor = (g: IndividualGuarantor | EntityGuarantor): g is IndividualGuarantor => {
  return g.type == 'Individual';
}

export const individualGuarantors = (guarantors: (IndividualGuarantor | EntityGuarantor)[] | null): IndividualGuarantor[] => {
  const i: IndividualGuarantor[] = [];
  for (const g of (guarantors ?? [])) {
    if (g.type == 'Individual') {
      i.push(g);
    }
  }
  return i;
}




// ========================================================================
// === IncomeSelectionValue parsing
// =======================================================================
export const fromIncomeSelectionValueMonthlyIncome = (value: IncomeSelectionValue): number => {
  if (value) {
    switch (value.period.type) {
      case 'Weekly': {
        return (value.income * 4);
      }
      case 'Fortnightly': {
        return value.income * 2;
      }
      default: {  // monthly
        return value.income;
      }
    }
  }
  return 0;
}

// ========================================================================
// === text / number parsing
// =======================================================================
export const asNumber = (number: string | number, decimals: number = 2): number | null => {
  const d = decimals <= 0 ? 0 : decimals;
  // workout the format eg. 2 decimals => 0.00, 3 decimals => 0.000
  const format = d <= 0 ? '0' : (Array.from(Array(d)).reduce((acc, curr) => {
    const r = `${acc}0`;
    return r;
  }, '0.'));
  return numeral(numeral(number).format(format)).value();
}

export const textWithLineBreaksToHtml = (text: string): string => {
  const r = (text ? `<p>${text}</p>` : '')
    .replace(/\r\n\r\n/g, '</p><p>')
    .replace(/\n\n/g, '</p><p>')
    .replace(/\r\n/g, '<br/>')
    .replace(/\n/g, '<br/>')
    ;
  return r;
}

export const countWordsInText = (text: string): number => {
  const words = (text ?? '')
    .trim()
    .replace(/\r|\n/g, ' ')
    .trim()
    .split(/\n|\s{1,}/g);
  return words.length > 0 ? words.length : 0;
}

export const wordsInText = (text: string, wordsCount: number): string => {
  const words = (text ?? '')
    .trim()
    .replace(/\r|\n/g, ' ')
    .trim()
    .split(/\n|\s{1,}/g);
  return (words ?? []).slice(0, wordsCount).join(' ');
}

export const parseCurrency = (num: number) => {
  return parseFloat(num.toFixed(2));
}

export const alphanumericOnly = (input: string) => {
  if (input) {
    return input.replace(/[^\w\s]/gi, '');
  }
  return input;
}

export const patchABAAllowedChar = (s: string): string => {
  return s.replace(/[^a-zA-Z0-9()&\s]+/gi, "").trim();
}


// =================================
// === Compare / Sort
// =================================
export const filterOut = <T>(i: T[], fn: (a: T, b: T) => boolean): T[] => {
  return (i ?? []).reduce((acc: T[], current) => {
    const found = acc.find(t => fn(t, current));
    if (!found) {
      acc.push(current);
    }
    return acc;
  }, []);
}
export const filterOutUniquePrimaryContacts = (contacts: ContactValue[]): ContactValue[] => {
  return filterOut((contacts ?? []), (a, b) => {
    return (
      a.title?.type == b.title?.type &&
      a.firstName == b.firstName &&
      a.lastName == b.lastName
    );
  });
}
export const compare = (a: number | string, b: number | string, isAsc: boolean): number => {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

// ==========================
// ====  Javascript File utils
// ==========================
export const filesToBase64Files = async (files: any[]): Promise<Base64File[]> => {
  const base64Files: Base64File[] = [];
  for (const file of (files ?? [])) {
    const base64Content = await fileToBase64(file);
    const base64File = {
      name: file.name,
      size: file.size,
      type: file.type,
      base64: base64Content,
      tags: file.tags ?? [],
      metadata: file?.metadata ?? []
    };
    base64Files.push(base64File);
  }
  return base64Files;
}

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      res(reader.result as string);
    }
    reader.onerror = error => rej(error);
  });
}

export const isBase64File = (f: any): f is Base64File => {
  return (f && f.base64);
}


export const getFileTags = (file: AzureFileTagable): string[] => {
  const allTags: DocumentTag[] = Object.values(constants.documentTypes);

  if (file?.tags) {
    const tags = Object.values(file.tags);
    return tags.map(tag => {
      const matchedTag = allTags.find(t => t.value === tag);
      if (matchedTag) {
        return matchedTag.type;
      }
      return '';
    })
  }
  return [];
}

// Convert to Base64
export const uint8ToBase64 = (uint8: Uint8Array): string => {
  let binary = '';
  for (let i = 0; i < uint8.length; i++) {
    binary += String.fromCharCode(uint8[i]);
  }
  return btoa(binary);
}



// ==========================
// ====   Display Conversion
// ==========================
export const booleanToYesNo = (bool: boolean | null | undefined): 'Yes' | 'No' => {
  return bool ? 'Yes' : 'No';
}

export const convertStringToBoolean = (value: string): boolean => {
  const truthyValues: string[] = ['true', 'True', '1', 'yes', 'Yes'];
  return truthyValues.includes(value);
};

export const yesNoToBoolean = (s: string): boolean => {
  return s.toLowerCase() === 'yes' ? true : false;
}

export const displayApplicationDateTime = (moment: Moment | null | undefined): string => {
  return moment ? moment.format('hh:mm a DD/MM/YYYY') : '';
}

export const displaybleDate = (moment: Moment | null | undefined): string => {
  return moment ? moment.format('DD/MM/YYYY') : '';
}

export const displayableDateTime = (moment: Moment | null | undefined): string => {
  return moment ? moment.format('DD/MM/YYYY hh:mm a') : '';
}

export const notNullUndefined = (a: any): boolean => {
  return (a !== null && a !== undefined);
}


// ==========================
// ====   Patching value
// ==========================
export const patchAcn = (_acn?: string | null) => {
  if (_acn) {
    let acn = String(_acn).trim();
    if (acn.toString().length < 9) {
      while (acn.toString().length < 9) {
        acn = '0' + acn
      }
    }
    return acn;
  }
  return _acn;
}



// ======================================================================================
// === Applications utils
// ======================================================================================
export const getApplicationStatus2 = (stage: string, salesforceId?: number | null | string):
  'Draft' | 'Declined' | 'Withdrawn' | 'Approved' | 'Under Review' | 'Settled' | 'Closed' | null => {
  let decision: 'Draft' | 'Declined' | 'Withdrawn' | 'Approved' | 'Under Review' | 'Settled' | 'Closed' | null = 'Under Review';
  if (!salesforceId && (!stage || stage == 'Draft')) {
    return 'Draft';
  } else if (!salesforceId && stage == 'Submitted to Credit') {
    decision = 'Under Review';
  } else if (stage == 'Submitted to Credit' ||
    stage == 'Waiting for Bank Statements' ||
    stage == 'More Information' ||
    stage == 'Lead'
  ) {
    decision = 'Under Review';
  } else if (stage == 'Credit Approved' ||
    stage == 'Documentation' ||
    stage == 'Docs Out' ||
    stage == 'Settlement Pending' ||
    stage == 'QA' ||
    stage == 'Settlement' ||
    stage == 'Compliance Review'
  ) {
    decision = 'Approved';
  } else if (stage == 'Closed Won') {
    decision = 'Settled';
  } else if (stage == 'Closed Lost with Loss Reason Category Withdrawn') {
    decision = 'Withdrawn';
  } else if (stage == 'Closed Lost with non Withdrawn reason') {
    decision = 'Declined';
  } else if (stage == 'Closed Lost') {
    decision = 'Closed'
  }
  return decision;
}
export const getApplicationStage2 = (stage?: string | null): string | 'Draft' => {
  return (stage != null && stage != undefined) ? stage : 'Draft';
}
export const getApplicationStatus = (application: Application):
  'Draft' | 'Declined' | 'Withdrawn' | 'Approved' | 'Under Review' | 'Settled' | 'Closed' | null => {
  let decision: 'Draft' | 'Declined' | 'Withdrawn' | 'Approved' | 'Under Review' | 'Settled' | 'Closed' | null = null;
  if (application) {
    const stageName = application.AppInfoStageName ?? application.InteflowStatus?.StageName ?? '';
    const salesforceId = application.AppInfoSalesforceID;

    decision = getApplicationStatus2(stageName, salesforceId);

  }
  return decision;
}

export const getApplicationStage = (application: Application): string | 'Draft' => {
  const appInfo = (application.AppInfo) ?? null;
  const stageName = getApplicationStage2(appInfo?.StageName);
  return stageName;
}

export const applicationStageAllowGenerateContract = (application: Application): boolean => {
  const stageName = getApplicationStage(application).toLowerCase();
  return !["lead", "submitted to credit", "waiting for bank statements", "more information", "closed lost", "closed won"].includes(stageName);
}

export const applicationStageAllowSettleLoan = (application: Application): boolean => {
  const stageName = getApplicationStage(application).toLowerCase();
  return ['documentation', 'docs out', 'settlement pending', 'qa'].includes(stageName);
}

export const applicationStageNotAllowDisbursementChange = (application: Application): boolean => {
  const stageName = getApplicationStage(application).toLowerCase();
  return ['settlement', 'closed won'].includes(stageName);
}

export const getOrgTypeByEntityText = (entityText: string): 'Other' | 'Trust' | 'Partnership' | 'Company' => {
  const orgType = 'Other';
  if (entityText.toLowerCase().indexOf('trust') != -1) {
    return 'Trust';
  } else if (entityText.toLowerCase().indexOf('partnership') != -1) {
    return 'Partnership';
  } else if (entityText.toLowerCase().indexOf('company') != -1) {
    return 'Company';
  }
  return orgType;
}


/**
 * Builds the "Name on contract" for a trust backed by a corporate trustee:
 *   [Trustee Entity Name] IIOR & ATF [Trust Name]
 *
 * Deduplicates the trust name: if LegalName was already written back from SF
 * (e.g. already "TRUSTEE IIOR & ATF TRUST"), the trustee prefix is stripped
 * before re-applying the formula, preventing compounding on repeated SF syncs.
 */
export const buildTrustIiorName = (trusteeLegalName: string, trustLegalName: string): string => {
  const trusteeUpper = trusteeLegalName.toUpperCase();
  const iiorPrefix = `${trusteeUpper} IIOR & ATF `;
  let trustUpper = trustLegalName.toUpperCase().replace('THE TRUSTEE FOR ', '');
  if (trustUpper.startsWith(iiorPrefix)) {
    trustUpper = trustUpper.slice(iiorPrefix.length);
  }
  return `${trusteeUpper} IIOR & ATF ${trustUpper}`;
};

// AssetOppMap() in Python API
export const applicationToSfData = (data: SalesforceSyncApplication, accountId: string): SFOpportunityData => {
  const primary = primaryEntityOf(data.parties);
  const opportunity: SFOpportunityData = {
    AccountId: accountId,
  };
  try {
    // A submitter without a Salesforce Contact is stored with an empty Id (B21); sending it would blank the field.
    if (data?.BrokerContact?.Id) {
      opportunity["BrokerContact__c"] = data.BrokerContact.Id;
    }
  } catch (e) {
    console.log(e);
  }
  if (data?.PricingDetails && "MonthlyFacilityFeePercentage" in data.PricingDetails) {
    opportunity["MonthlyFacilityFeePercentage__c"] = _.round(data.PricingDetails?.MonthlyFacilityFeePercentage ?? 0, 2);
  }
  if (data?.AppInfo?.productType) {
    opportunity["Product__c"] = data.AppInfo.productType;
  }
  if (data?.PricingDetails?.RepaymentType) {
    opportunity["Payment_Type__c"] = data.PricingDetails.RepaymentType;
  } else {
    opportunity["Payment_Type__c"] = "Advance";
  }
  if (data?.AppInfo?.isSwitchToEasyDoc) {
    opportunity["isSwitchToEasyDoc__c"] = data.AppInfo.isSwitchToEasyDoc ;
  }else {
    opportunity["isSwitchToEasyDoc__c"] = false;
  }
  opportunity["FrankieOne_Completed__c"] = !!data?.FrankieOneCompleted;
  opportunity["Docusign_Privacy_Completed__c"] = !!data?.DocusignPrivacyCompleted;

  if (data?.AppInfo?.FinanceType === "Business Loan") {
    opportunity["RecordTypeId"] = "0127F000000yxCEQAY";
    opportunity["Sale_And_Rent_Back__c"] = "No";
    opportunity["Private_Sale__c"] = "No";
    opportunity["Product__c"] = "BUSINESS LOAN";
  } else if (data?.AppInfo?.FinanceType === "Business Overdraft") {
    opportunity["RecordTypeId"] = "0128t0000004I2jAAE";
    opportunity["Sale_And_Rent_Back__c"] = "No";
    opportunity["Payment_Type__c"] = "Arrears";
    opportunity["Private_Sale__c"] = "No";
    opportunity["FacilityEstablishmentFee__c"] = data?.PricingDetails?.FacilityEstablishmentFee ?? 0;
    opportunity["Facility_Establishment_Fee__c"] = data?.PricingDetails?.FacilityEstablishmentFeePercent ?? 0;
    opportunity["Brokerage__c"] = data?.PricingDetails?.BrokerageDollar ?? 0;
    if (data?.AppInfo?.ApplicationType === "CorporateLoans") {
      opportunity["Product__c"] = "Corporate Loan";
    }
  } else {
    opportunity["RecordTypeId"] = "0127F000000yiLjQAI";
    try {
      if (data?.AssetSpec?.year) {
        opportunity["Asset_Year__c"] = data?.AssetSpec?.year;
      }
    } catch (e) {
      console.log(e);
    }
    if (data?.AppInfo?.FinanceType) {
      opportunity["ProductType__c"] = data.AppInfo.FinanceType;
    }
    if (data?.PricingDetails?.OversCommission) {
      opportunity["Overs_Commission__c"] = _.round(data.PricingDetails.OversCommission, 2);
    }
    if (data?.PricingDetails?.AssetCondition) {
      opportunity["New_or_Used__c"] = data.PricingDetails.AssetCondition;
    }
    if (data?.PricingDetails?.TreasuryAssetCondition) {
      opportunity["Treasury_Asset_Condition__c"] = data.PricingDetails.TreasuryAssetCondition;
    }
    if (data?.PricingDetails?.PrivateSale) {
      opportunity["Private_Sale__c"] = data.PricingDetails.PrivateSale;
    }
    if (data?.PricingDetails?.SaleRentBack) {
      opportunity["Sale_And_Rent_Back__c"] = data.PricingDetails.SaleRentBack;
    }
    // ADO 1752: against InvoiceAmount, not LoanAmount, so the percentage we push matches the one
    // credit and the calculator use. Nothing currently writes PricingDetails.ResidualValue (the
    // live field is BalloonPayment, pushed as Residual_Value__c below), but a legacy stored blob
    // may carry it. On the loan basis this pushed an inflated percentage that came back on the echo
    // alongside Residual_Value__c, and syncPricingDetails does not recompute when both are present,
    // so it would have been stored verbatim.
    if (data?.PricingDetails?.ResidualValue && data?.PricingDetails.InvoiceAmount) {
      opportunity["ec1_ResidualValue__c"] = _.round(data.PricingDetails.ResidualValue * 100 / data.PricingDetails.InvoiceAmount, 2);
    }
    if (data?.PricingDetails?.ResidualValue) {
      opportunity["Residual_Value__c"] = data.PricingDetails.ResidualValue;
    }
    if (data?.AssetSpec?.description) {
      opportunity["Goods_Description__c"] = `${data.AssetSpec.description}`;
      opportunity["Make__c"] = `${data?.AssetSpec?.make ? data?.AssetSpec?.make + ' ' : ''}` +
        `${data?.AssetSpec?.family ? data?.AssetSpec?.family + ' ' : ''}`;
    } else if (data?.AssetSpec?.vehicle) {
      opportunity["Goods_Description__c"] = `${data.AssetSpec.vehicle}`;
      opportunity["Make__c"] = `${data?.AssetSpec?.make ? data?.AssetSpec?.make + ' ' : ''}` +
        `${data?.AssetSpec?.family ? data?.AssetSpec?.family + ' ' : ''}`;
    }
    if (data?.AssetSpec?.LVR) {
      opportunity["LVR__c"] = data.AssetSpec.LVR;
    }
    if (data?.AppInfo?.AssetCategory) {
      opportunity["Asset_Category__c"] = data?.AppInfo?.AssetCategory;
      if ((data?.AppInfo as any)?.AssetType) {
        opportunity["Asset_Type__c"] = `${data?.AppInfo?.AssetCategory ?? ''}-${(data?.AppInfo as any)?.AssetType ?? ''}`;
      }
    }
    if (data?.PricingDetails?.BalloonPayment) {
      opportunity["Residual_Value__c"] = data.PricingDetails.BalloonPayment;
    }
  }

  if (primary?.legalName) {
    opportunity["Name"] = primary.legalName.length > 120 ?
      primary.legalName.slice(0, 118) + ".." :
      primary.legalName;
  }
  opportunity["CloseDate"] = moment().add(2, "months").format("YYYY-MM-DD");
  opportunity["StageName"] = "Submitted to Credit";
  if (data?.PricingDetails?.InvoiceAmount) {
    opportunity["Amount"] = data.PricingDetails.InvoiceAmount;
  } else {
    opportunity["Amount"] = data.PricingDetails.LoanAmount;
  }
  if (data?.PricingDetails?.LoanTerm) {
    opportunity["ec1_Term__c"] = data.PricingDetails.LoanTerm;
  }
  if (data?.PricingDetails?.PaymentPeriod) {
    opportunity["Repayment_Frequency__c"] = data.PricingDetails.PaymentPeriod;
  }
  if (data?.PricingDetails?.PropertyOwner) {
    opportunity["PropertyOwnership__c"] = data.PricingDetails.PropertyOwner;
  }
  opportunity["Inteflow_Reference_Id__c"] = "Placeholder";
  opportunity["Doc_Fee_Financed__c"] = data?.PricingDetails?.DocFeeFinanced === "Yes";
  if (data?.PricingDetails?.Brokerage) {
    opportunity["Brokerage_Percentage__c"] = data.PricingDetails.Brokerage;
  } else {
    opportunity["Brokerage__c"] = 0;
  }
  if (data?.PricingDetails?.BrokerOriginationFee) {
    opportunity["Broker_Origination_Fee__c"] = data.PricingDetails.BrokerOriginationFee;
  }
  if (data?.PricingDetails?.DocFee) {
    opportunity["Documentation_Fee__c"] = data.PricingDetails.DocFee;
  }
  if (data?.PricingDetails?.Deposit) {
    opportunity["Deposit_where_applicable__c"] = data.PricingDetails.Deposit;
  }
  if (data?.PricingDetails?.SaleRentBack != "Yes") {
    opportunity["Sale_And_Rent_Back__c"] = "No";
  } else {
    opportunity["Sale_And_Rent_Back__c"] = "Yes";
  }
  if (data?.AppInfo?.BrokerSalesforceID) {
    opportunity["ec1_Introducer__c"] = data.AppInfo.BrokerSalesforceID;
  }
  if (data?.AppInfo?.UserEmail) {
    opportunity["Portal_User_Email__c"] = data.AppInfo.UserEmail;
  }
  if (data?.AppInfo?.UserFirstName) {
    opportunity["Portal_User_First_Name__c"] = data.AppInfo.UserFirstName;
  }
  if (data?.AppInfo?.UserLastName) {
    opportunity["Portal_User_Last_Name__c"] = data.AppInfo.UserLastName;
  }
  if (data?.PricingDetails?.Rate) {
    opportunity["Rate__c"] = _.round(data.PricingDetails.Rate, 2);
  }
  if (data?.PricingDetails?.Margin) {
    opportunity["Margin__c"] = _.round(data.PricingDetails.Margin, 2);
  }
  if (data?.AppInfo?.Notes) {
    opportunity["Notes__c"] = data.AppInfo.Notes;
  }
  if (data?.AppInfo?.BrokerSalesforceID) {
    opportunity["ec1_Introducer__c"] = data.AppInfo.BrokerSalesforceID;
  }
  if ((data?.AppInfo as any)?.Type === "New") {
    opportunity["Type"] = "New Business";
  } else if ((data?.AppInfo as any)?.Type === "Existing") {
    opportunity["Type"] = "Existing Business";
  }
  if ((data?.AppInfo as any)?.OwnerId) {
    opportunity["OwnerId"] = (data?.AppInfo as any).OwnerId;
  }
  if (data?.PricingDetails?.APR) {
    opportunity["APR__c"] = _.round(data.PricingDetails.APR, 2);
  }
  if (data?.AdditionalBrokerCorrespondent) {
    opportunity["Broker_Contact_Add__c"] = data.AdditionalBrokerCorrespondent.Name;
    opportunity["Broker_Email_Add__c"] = data.AdditionalBrokerCorrespondent.Email;
  }
  if (primary?.entityType === "TRST") {
    const trustee = (data.parties?.commercialEntities ?? []).find(entity => entity.isBorrower && commercialEntityRoleType(entity) === 'Trustee');
    if (trustee) {
      const oppoName = buildTrustIiorName(trustee.legalName ?? '', primary.legalName ?? '');
      opportunity["Name"] = oppoName.length > 120 ? `${oppoName.slice(0, 118)}..` : oppoName;
    }
  }
  if (data?.AppInfo?.BrokerAppID) {
    opportunity["PortalLink__c"] = `https://portal.dynamoney.com/s/application/${data.AppInfo.BrokerAppID.slice(1)}/documents`;
  }
  if (data?.AppInfo?.LoanPurpose) {
    opportunity["Loan_Purpose__c"] = data.AppInfo.LoanPurpose.name;
  }

  return opportunity;
}

/** Fields that belong on opportunity create, not on cronSubmitApplication resync (ADO 1648). */
export const omitOpportunityCreateOnlyFieldsOnUpdate = (opportunity: SFOpportunityData): void => {
  delete opportunity.StageName;
  delete opportunity.Rate__c;
  delete opportunity.CloseDate;
};

const APPLICATION_PRICING_FROM_CONTRACT_KEYS: (keyof ContractPricingDetails)[] = [
  'InvoiceAmount',
  'Deposit',
  'LoanAmount',
  'AmountFinance',
  'BalloonPaymentPercentage',
  'BalloonPayment',
  'Repayment',
  'BrokerageAmount',
  'Brokerage',
  'BrokerageDollar',
  'BrokerOriginationFee',
  'DocFeeFinanced',
  'APR',
  'Rate',
  'Margin',
  'FacilityEstablishmentFee',
  'RateDiscount',
  'OversCommission',
];

/**
 * Overlay the generate-contract snapshot onto Application.PricingDetails.
 * JSON keys follow the old syncPricingDetails echo of the DocuSign Salesforce patch
 * (Invoice_Price__c → InvoiceAmount, Amount → LoanAmount for BL/BO, Brokerage__c → BrokerageAmount
 * plus BrokerageDollar for overdraft). Rate goes to Rate (portal-owned), not RateSf.
 */
export const mergeContractSnapshotIntoPricingDetails = (
  existing: Record<string, unknown> | null | undefined,
  snapshot: ContractPricingDetails | null | undefined,
): Record<string, unknown> => {
  const next: Record<string, unknown> = { ...(existing ?? {}) };
  if (!snapshot) {
    return next;
  }
  for (const key of APPLICATION_PRICING_FROM_CONTRACT_KEYS) {
    if (Object.prototype.hasOwnProperty.call(snapshot, key) && snapshot[key] !== undefined) {
      next[key] = snapshot[key];
    }
  }
  if (Object.prototype.hasOwnProperty.call(snapshot, 'Rate') && snapshot.Rate !== undefined) {
    next['InterestRate'] = snapshot.Rate;
  }
  // BL/BO DocuSign writes loan amount to Invoice_Price__c; echo maps that to InvoiceAmount.
  if (
    snapshot.LoanAmount !== undefined &&
    !Object.prototype.hasOwnProperty.call(snapshot, 'InvoiceAmount')
  ) {
    next['InvoiceAmount'] = snapshot.LoanAmount;
  }
  // Echo Residual_Value__c ← BalloonPayment when only residual % is on the snapshot.
  // ADO 1752: against InvoiceAmount, not LoanAmount. The percentage is a percentage of the invoice
  // everywhere else (calculateResidualValue, and the `Residual Percentage` credit rule item), so
  // deriving it here against Invoice − Deposit understated the dollar amount credit then reads.
  // BL/BO snapshots carry no InvoiceAmount, but the fallback above has already set it from
  // LoanAmount by this point, which is the right basis for them.
  if (
    snapshot.BalloonPaymentPercentage !== undefined &&
    snapshot.BalloonPayment === undefined &&
    Number(next['InvoiceAmount'])
  ) {
    next['BalloonPayment'] = Number((snapshot.BalloonPaymentPercentage * Number(next['InvoiceAmount']) / 100).toFixed(2));
  }
  return next;
};

// IPFOppMap() in Python API
export const insurancePremiumApplicationToSfData = (data: SalesforceSyncApplication, accountId: string): SFOpportunityData => {
  const primary = primaryEntityOf(data.parties);
  const opportunity: SFOpportunityData = {
    AccountId: accountId,
    RecordTypeId: "0127F000000yxjrQAA",
    Goods_Description__c: "Trade Finance Application",
    Brokerage__c: 0,
  };
  try {
    if (data?.BrokerContact?.Id) {
      opportunity["BrokerContact__c"] = data.BrokerContact.Id;
    }
  } catch (e) {
    console.log(e);
  }
  if (primary?.legalName) {
    opportunity["Name"] = primary.legalName.length > 120 ?
      primary.legalName.slice(0, 118) + ".." :
      primary.legalName;
  }
  opportunity["CloseDate"] = moment().add(2, "months").format("YYYY-MM-DD");
  opportunity["StageName"] = "Submitted to Credit";
  if (data?.PricingDetails?.LimitRequest) {
    opportunity["Amount"] = data.PricingDetails.LimitRequest;
  }
  if ((data?.PricingDetails as any)?.TotalAmount) {
    opportunity["Amount"] = (data.PricingDetails as any).TotalAmount;
  }
  if (data?.PricingDetails?.DocFee) {
    opportunity["Documentation_Fee__c"] = data.PricingDetails.DocFee;
  }
  if (data?.AppInfo?.FinanceType) {
    opportunity["ProductType__c"] = data.AppInfo.FinanceType;
  }
  if (data?.AppInfo?.BrokerSalesforceID) {
    opportunity["ec1_Introducer__c"] = data.AppInfo.BrokerSalesforceID;
  }
  if (data?.AppInfo?.UserEmail) {
    opportunity["Portal_User_Email__c"] = data.AppInfo.UserEmail;
  }
  if (data?.AppInfo?.UserFirstName) {
    opportunity["Portal_User_First_Name__c"] = data.AppInfo.UserFirstName;
  }
  if (data?.AppInfo?.UserLastName) {
    opportunity["Portal_User_Last_Name__c"] = data.AppInfo.UserLastName;
  }
  if (data?.AppInfo?.Notes) {
    opportunity["Notes__c"] = data.AppInfo.Notes;
  }
  if ((data?.AppInfo as any)?.OwnerId) {
    opportunity["OwnerId"] = (data?.AppInfo as any).OwnerId;
  }
  if (data?.PricingDetails?.LoanTerm) {
    opportunity["ec1_Term__c"] = data.PricingDetails.LoanTerm;
  }
  if (data?.PricingDetails?.PaymentPeriod) {
    opportunity["Repayment_Frequency__c"] = data.PricingDetails.PaymentPeriod;
  }
  if (data?.PricingDetails?.Rate) {
    opportunity["Rate__c"] = _.round(data.PricingDetails.Rate, 2);
  }
  opportunity["Doc_Fee_Financed__c"] = data?.PricingDetails?.DocFeeFinanced === "Yes";
  if (data?.PricingDetails?.Brokerage) {
    opportunity["Brokerage_Percentage__c"] = data.PricingDetails.Brokerage;
  }
  if (data?.AdditionalBrokerCorrespondent) {
    opportunity["Broker_Contact_Add__c"] = data.AdditionalBrokerCorrespondent.Name;
    opportunity["Broker_Email_Add__c"] = data.AdditionalBrokerCorrespondent.Email;
  }
  if (data?.AppInfo?.BrokerAppID) {
    opportunity["PortalLink__c"] = `https://portal.dynamoney.com/s/application/${data.AppInfo.BrokerAppID.slice(1)}/documents`;
  }
  if (data?.AppInfo?.LoanPurpose) {
    opportunity["Loan_Purpose__c"] = data.AppInfo.LoanPurpose.name;
  }

  return opportunity;
}

// AccreditationOppMap in Python API
export const accreditationToSfData = (data: SubmitAccreditationInput, accountId: string): SFOpportunityData => {
  return {
    "RecordTypeId": "0127F000001CfIeQAK",
    "Name": data.companyName.length > 120 ? data.companyName.slice(0, 118) + '..' : data.companyName,
    "CloseDate": moment().add(2, "months").format("YYYY-MM-DD"),
    "StageName": "Submitted to Credit",
    "Inteflow_Reference_Id__c": "Placeholder",
    "AccountId": accountId,
  }
}

export const sfEntityType = (Value: string) => {
  if (Value == 'PTY')
    return 'Proprietary'
  else if (Value == 'P/L')
    return 'Proprietary Limited'
  else if (Value == 'N/L')
    return 'No Liability'
  else if (Value == 'INC')
    return 'Incorporated'
  else if (Value == 'LTD')
    return 'Limited'
  else if (Value == 'R/B')
    return 'Registered Body'
  else if (Value == 'CORP')
    return 'Corporation'
  else if (Value == 'BUS')
    return 'Business'
  else if (Value == 'SLTR')
    return 'Sole Trader'
  else if (Value == 'PTNR')
    return 'Partnership'
  else if (Value == 'TRST')
    return 'Trust'
  else
    return ''
}

export const assetAccountMap = (data: SalesforceSyncApplication): SFAccountData => {
  const primary = primaryEntityOf(data.parties);
  const address = primary?.principalPlaceOfBusiness;
  const accountObject: SFAccountData = {
    "RecordTypeId": "0127F000000yiLaQAI",
    "ec1_ABN__c": primary?.abn ?? '',
    "ec1_ACN__c": primary?.acn ?? '',
    "AnnualRevenue": primary?.revenue ?? 0,
    "ec1_ANZSICCode__c": `${primary?.industry?.primaryIndustry ?? ''}-${primary?.industry?.industryClass ? primary.industry.industryClass.replace(/^\s+/, '') : (primary?.industry?.industrySector?.replace(/^0+/, '') ?? '')}`,
    "ec1_EntityType__c": primary?.businessCategory ?? '',
    "ec1_Industry__c": primary?.industry?.primaryIndustry ?? '',
    "Interflow_Entity_Type__c": sfEntityType(primary?.entityType ?? ''),
    "ec1_TradingName__c": primary?.tradingName ?? '',
    "Type": "Customer",
    "Name": (primary?.legalName ?? '').slice(0, 255),
    "ec1_Email__c": data?.Contacts?.Email ?? '',
    "BillingStreet": `${address?.unitNumber ?? ''} ${address?.streetNumber ?? ''} ${address?.streetName ?? ''} ${address?.streetType ?? ''}`,
    "BillingCity": address?.suburb ?? '',
    "BillingState": address?.state ?? '',
    "BillingPostalCode": address?.postcode ?? '',
    //"NumberOfEmployees": nstr(Data['CommercialEntities'][0].get('NoEmployees')),
    "Phone": `${primary?.areaCode ?? ''}${primary?.phoneNumber ?? ''}`,
  }

  if (primary?.entityType === "TRST") {
    const trustee = (data.parties?.commercialEntities ?? []).find(entity => entity.isBorrower && commercialEntityRoleType(entity) === 'Trustee');
    if (trustee) {
      accountObject["ec1_ACN__c"] = trustee.acn ?? '';
      accountObject["Name"] = buildTrustIiorName(trustee.legalName ?? '', primary.legalName ?? '').slice(0, 255);
    }
  }

  if (data?.AppInfo?.FinanceType === 'Business Loan') {
    accountObject["Business_Loans__c"] = true;
  } else if (data?.AppInfo?.FinanceType === 'Trade Finance') {
    accountObject["Trade_Finance__c"] = true;
  } else if (data?.AppInfo?.FinanceType === 'Insurance Premium') {
    accountObject["Insurance_Premium_Finance__c"] = true;
  } else {
    accountObject["Asset_Finance__c"] = true;
  }

  if (data?.AppInfo?.OwnerId) {
    accountObject["OwnerId"] = data.AppInfo.OwnerId;
  }

  return accountObject;
}

type SalesforceSyncIndividual = NonNullable<SalesforceSyncApplication['parties']>['individuals'][number];

/** Whether the individual is the application's contact, the first Contact `assetContactMap` maps. */
const isApplicationContactIndividual = (data: SalesforceSyncApplication, ind: SalesforceSyncIndividual): boolean =>
  ind?.givenName === (data?.Contacts?.GivenName ?? '') && ind?.surname === (data?.Contacts?.SurName ?? '') && ind?.email === (data?.Contacts?.Email ?? '');

/** The ApplicationIndividual id of each Contact `assetContactMap` maps, in its order; null for none. */
export const assetContactIndividualIds = (data: SalesforceSyncApplication): (number | null)[] => {
  const ids: (number | null)[] = [null];
  for (const ind of data.parties?.individuals ?? []) {
    if (isApplicationContactIndividual(data, ind)) {
      ids[0] = ind.id ?? null;
    } else if (ind.isGuarantor) {
      ids.push(ind.id ?? null);
    }
  }
  return ids;
};

export const assetContactMap = (data: SalesforceSyncApplication): SFContactArrayData => {
  const contactObject: SFContactArrayData = {
    "RecordTypeId": "0127F000000yiLeQAI",
    "FirstName": [data?.Contacts?.GivenName ?? ''],
    "LastName": [data?.Contacts?.SurName ?? ''],
    "Salutation": [data?.Contacts?.Title ?? ''],
    "Email": [data?.Contacts?.Email ?? ''],
    "MobilePhone": [data?.Contacts?.Mobile ?? ''], // TO DO: re.sub(r'(\d)\s+(\d)', r'\1\2', xsstr(Data['Contacts'].get('Mobile')))
    "Phone": [(data?.PricingDetails as any)?.Telephone ?? ''],
    "ec1_DateofBirth__c": [''],
    "MailingStreet": [''],
    "MailingCity": [''],
    "MailingState": [''],
    "MailingPostalCode": [''],
    "ec1_Guarantor__c": [false],
    "Not_a_contract_signer__c": [false],
  };

  for (const ind of data.parties?.individuals ?? []) {
    const home = ind.homeAddress;
    const signerRole = individualSignerRole(ind);
    const notASigner = !(signerRole === 'GuarantorSigner' || signerRole === 'Signer');
    if (isApplicationContactIndividual(data, ind)) {
      // same person
      contactObject["MailingStreet"][0] = `${home?.streetNumber ?? ''} ${home?.streetName ?? ''} ${home?.streetType}`;
      contactObject["MailingCity"][0] = home?.suburb ?? '';
      contactObject["MailingState"][0] = home?.state ?? '';
      contactObject["MailingPostalCode"][0] = home?.postcode ?? '';
      contactObject["ec1_DateofBirth__c"][0] = ind?.dateOfBirth ?? '';
      contactObject["ec1_Guarantor__c"][0] = ind.isGuarantor;
      contactObject["Not_a_contract_signer__c"][0] = notASigner;
    } else if (ind.isGuarantor) {
      // not the same person
      contactObject["FirstName"].push(ind?.givenName ?? '');
      contactObject["Salutation"].push(ind?.title ?? '');
      contactObject["LastName"].push(ind?.surname ?? '');
      contactObject["Email"].push(ind?.email ?? '');
      contactObject["MobilePhone"].push(ind?.mobileNumber ?? ''); //TO DO: re.sub(r'(\d)\s+(\d)', r'\1\2', xsstr(ind['MobileNumber'])))
      contactObject["MailingStreet"].push(`${home?.streetNumber ?? ''} ${home?.streetName ?? ''} ${home?.streetType}`);
      contactObject["MailingCity"].push(home?.suburb ?? '');
      contactObject["MailingState"].push(home?.state ?? '');
      contactObject["MailingPostalCode"].push(home?.postcode ?? '');
      contactObject["ec1_DateofBirth__c"].push(ind?.dateOfBirth ?? '');
      contactObject["Phone"].push('');
      contactObject["ec1_Guarantor__c"].push(ind.isGuarantor);
      contactObject["Not_a_contract_signer__c"].push(notASigner);
    }
  }

  return contactObject;
}

// AccreditationAccMap in Python API
export const accreditationAccountMap = (data: SubmitAccreditationInput): SFAccountData => {
  const accountObject: SFAccountData = {
    "RecordTypeId": data.Type ?? '',
    "ec1_ABN__c": data.abn,
    "ec1_ACN__c": data.acn,
    "Interflow_Entity_Type__c": sfEntityType(data?.entityType ?? ''), // TO DO
    "Name": data.companyName.slice(0, 255),
    "ec1_Email__c": data.email ?? '',
    "BillingStreet": `${data?.businessAddress?.UnitNumber ?? ''} ${data?.businessAddress?.StreetNumber ?? ''} ${data?.businessAddress?.StreetName ?? ''} ${data?.businessAddress?.StreetType ?? ''}`,
    "BillingCity": data?.businessAddress?.Suburb ?? '',
    "BillingState": data?.businessAddress?.State ?? '',
    "BillingPostalCode": data?.businessAddress?.Postcode ?? '',
    "Phone": data.officeNumber,
  }

  if (data?.groupOrAggregatorName) {
    accountObject["Aggregator__c"] = data.groupOrAggregatorName;
  }
  if (data?.Products?.assetFinance) {
    accountObject["Asset_Finance__c"] = true;
  }
  if (data?.Products?.businessLoan) {
    accountObject["Business_Loans__c"] = true;
  }
  if (data?.Products?.insurancePremium) {
    accountObject["Insurance_Premium_Finance__c"] = true;
  }

  return accountObject;
}

// AccreditationContactMap in Python API
export const accreditationContactMap = (data: SubmitAccreditationInput, accountId: string): SFContactData => {
  const contactObject: SFContactData = {
    "AccountId": accountId,
    "RecordTypeId": "0127F000000yiLeQAI",
    "FirstName": data?.givenName ?? '',
    "LastName": data?.surName ?? '',
    "Salutation": data?.title ?? '',
    "Email": data?.email ?? '',
    "MobilePhone": data?.mobileNumber ?? '',
    "Phone": data?.officeNumber ?? '',
    "MailingStreet": `${data?.residentialAddress?.StreetNumber ?? ''} ${data?.residentialAddress?.StreetName ?? ''} ${data?.residentialAddress?.StreetType}`,
    "MailingCity": data?.residentialAddress?.Suburb ?? '',
    "MailingState": data?.residentialAddress?.State ?? '',
    "MailingPostalCode": data?.residentialAddress?.Postcode ?? '',
    "ec1_DateofBirth__c": data?.dob ?? '',
  }

  if (data?.driverLicenceNumber) {
    contactObject["ec1_DriversLicence__c"] = data.driverLicenceNumber;
  }
  if (data?.driverLicenceExpiryDate) {
    contactObject["Expiry_Date__c"] = data.driverLicenceExpiryDate;
  }
  if (data?.driverLicenceIssuingState) {
    contactObject["State__c"] = data.driverLicenceIssuingState;
  }
  return contactObject;
}

export const getApplicationCreditorWatchScore = (application: CreditRuleInput) => {
  const primaryEntity = application.commercialEntities.find(entity => entity.isPrimary);
  if (primaryEntity) {
    const creditorWatch = primaryEntity.CreditorWatch;
    if (!creditorWatch) {
      return 9999;
    }
    return creditorWatch?.creditScore?.currentCreditScore ?? 9999;
  } else {
    return 9999;
  }
}

export const getMaxDirectorEquifax = (application: CreditRuleInput) => {
  const individualEquifaxConsumerData = application.individuals
    .map(individual => individual.EquifaxConsumer)
    .filter((report): report is EquifaxConsumerReportData => !!report);
  if (individualEquifaxConsumerData.length) {
    const equifaxScores: number[] = individualEquifaxConsumerData.map(data =>
      data['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.
      ['vs:product-data']?.['vs:score-data']?.['vs:score']?.['vs:score-masterscale'] ?? 9999);
    return Math.max(...equifaxScores);
  } else {
    return 9999;
  }
}

export const getMinDirectorEquifax = (application: CreditRuleInput) => {
  const individualEquifaxConsumerData = application.individuals
    .map(individual => individual.EquifaxConsumer)
    .filter((report): report is EquifaxConsumerReportData => !!report);
  if (individualEquifaxConsumerData.length) {
    const equifaxScores: number[] = individualEquifaxConsumerData.map(data =>
      data['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.
      ['vs:product-data']?.['vs:score-data']?.['vs:score']?.['vs:score-masterscale'] ?? 9999);
    return Math.min(...equifaxScores);
  } else {
    return 9999;
  }
}

// ==========================================================
// ======== asset finance calculation
// ==========================================================
export const isTier1Asset = (assetCategory: string): boolean => {
  const TIER1_ASSET_CATS = ['137'];
  return TIER1_ASSET_CATS.includes(assetCategory);
}

export const isTier2Asset = (assetCategory: string): boolean => {
  const TIER2_ASSET_CATS = ['132', '130', '140'];
  return TIER2_ASSET_CATS.includes(assetCategory);
}

export const isTier3Asset = (assetCategory: string): boolean => {
  const TIER3_ASSET_CATS = ['136', '133', '106'];
  return TIER3_ASSET_CATS.includes(assetCategory);
}

export const isTier4Asset = (assetCategory: string): boolean => {
  const TIER4_ASSET_CATS = ['134', '135', '142'];
  return TIER4_ASSET_CATS.includes(assetCategory);
}

export interface EOTValidationResult {
  isValid: boolean;
  eotAge: number;
  tier: number;
  maxEOT: number;
  errorMessage?: string;
}

/**
 * Calculate End of Term age for an asset
 * Formula: (current year - asset year - 1) + (loan term in months / 12)
 */
export const calculateEOTAge = (assetYear: number, loanTermMonths: number): number => {
  const currentYear = new Date().getFullYear();
  const eotAge = (currentYear - assetYear - 1) + (loanTermMonths / 12);
  return eotAge;
}

/**
 * Determine which tier an asset category belongs to
 */
export const getAssetTier = (assetCategoryIndex: string): number | null => {
  if (isTier1Asset(assetCategoryIndex)) return 1;
  if (isTier2Asset(assetCategoryIndex)) return 2;
  if (isTier3Asset(assetCategoryIndex)) return 3;
  if (isTier4Asset(assetCategoryIndex)) return 4;
  return null;
}

/**
 * Get the maximum EOT age allowed for a given asset tier
 * Based on the policy from creditLowDoc.ts:
 */
export const getMaxEOTForTier = (assetCategoryIndex: string, assetTypeIndex?: string): number | null => {
  
  switch (assetCategoryIndex) {
    // Tier 1 Cars and Light Commercial
    case '137':
      return 15;

    // Tier 2 Caravans  
    case '140':
      return 15;

    // Tier 2 Yellow Goods
    case '130':
      return ['2', '4', '6'].includes(assetTypeIndex ?? '') ? 15 : 20;

    // Tier 2 Trucks and Trailers
    case '132':
      return assetTypeIndex === '3' ? 20 : 25;

    // Tier 3 Solar
    case '106':
      return 7;

    // Tier 3 Other
    case '136':
    case '133':
      return 15;

    // Tier 4 Other  
    case '134':
    case '135':
    case '142':
      return 5;

    default:
      return null;
  }
}

/**
 * Max allowed loan term (months) per asset category, aligned with credit rule CRDL45.
 * Tier 1/2: 84 months, Tier 3 Solar: 84 months, Tier 3 other: 60 months, Tier 4: 60 months.
 */
export const getMaxLoanTermForTier = (assetCategoryIndex: string): number => {
  switch (assetCategoryIndex) {
    case '137':  // Tier 1
    case '132':  // Tier 2 Trucks
    case '130':  // Tier 2 Yellow Goods
    case '140':  // Tier 2 Caravans
    case '106':  // Tier 3 Solar
      return 84;
    case '136':  // Tier 3 Plant equipment
    case '133':  // Tier 3 Plant equipment
    case '134':  // Tier 4
    case '135':  // Tier 4
    case '142':  // Tier 4
      return 60;
    default:
      return 84;
  }
}

/**
 * Get tier name for display
 */
export const getTierName = (tier: number): string => {
  switch (tier) {
    case 1: return 'Tier 1';
    case 2: return 'Tier 2';
    case 3: return 'Tier 3';
    case 4: return 'Tier 4';
    default: return 'Unknown Tier';
  }
}

/**
 * Get category name for display
 */
export const getAssetCategoryName = (assetCategoryIndex: string): string => {
  // This should match the names from the image/requirements
  if (assetCategoryIndex === '137') return 'Cars and light commercial';
  if (assetCategoryIndex === '132') return 'Trucks and trailers';
  if (assetCategoryIndex === '140') return 'Caravans';
  if (assetCategoryIndex === '130') return 'Yellow goods';
  if (assetCategoryIndex === '106') return 'Solar';
  if (['136', '133'].includes(assetCategoryIndex)) return 'Plant equipment';
  if (['134', '135', '142'].includes(assetCategoryIndex)) return 'Other';
  return 'Unknown';
}

/**
 * Validate EOT age and return detailed result
 */
export const validateEOTAge = (
  assetYear: number,
  assetCategoryIndex: string,
  loanTermMonths: number,
  assetTypeIndex?: string
): EOTValidationResult => {
  const eotAge = calculateEOTAge(assetYear, loanTermMonths);
  const tier = getAssetTier(assetCategoryIndex);
  const maxEOT = getMaxEOTForTier(assetCategoryIndex, assetTypeIndex);

  if (tier === null || maxEOT == null) {
    return {
      isValid: true, // Don't block if tier unknown
      eotAge,
      tier: 0,
      maxEOT: maxEOT ?? 9999,
      errorMessage: undefined
    };
  }
  
  const isValid = eotAge <= maxEOT;
  
  if (!isValid) {
    const categoryName = getAssetCategoryName(assetCategoryIndex);
    const tierName = getTierName(tier);
    const errorMessage = `The asset and loan term you entered results in an EOT age of ${eotAge} years, exceeding our ${tierName} policy limit of ${maxEOT} years. Please shorten the term or choose a newer asset.`;
    
    return {
      isValid: false,
      eotAge,
      tier,
      maxEOT,
      errorMessage
    };
  }
  
  return {
    isValid: true,
    eotAge,
    tier,
    maxEOT
  };
}

export const isConsumerAssetForCar = (assetType: string): boolean => {
  const CONSUMER_ASSET_TYPES = ['1'];
  return CONSUMER_ASSET_TYPES.includes(assetType);
}

export const minDepositForPricingAssetFinance = (isCreditOrAdmin: boolean, invoiceAmount: number, assetCategoryIndex: string, isPropertyOwner: boolean | null, productType: AssetFinanceProductType = "FAST DOC"): number | null => {
  if (isCreditOrAdmin) {
    return 0;
  }
  return minDepositForAssetFinance(invoiceAmount, isPropertyOwner);
}

export const minDepositForAssetFinance = (invoiceAmount: number, isPropertyOwner: boolean | null, productType: AssetFinanceProductType = "FAST DOC"): number | null => {
  const apply20pDeposit = productType === "FAST DOC" && (!!!isPropertyOwner);

  if (apply20pDeposit) {
    const minDeposit = _.round(invoiceAmount * 0.2, 2); // 20% of invoiceAmount
    return minDeposit;
  } else {
    return 0;
  }
}

export const maxLoanForAssetFinance = (assetCategoryIndex: string, isPropertyOwner: boolean | null, docCriteria: AssetFinanceProductType): number => {
  const isAssetBacked = isPropertyOwner; //is propertyOwnership true mean asset backed
  let tier = null
  if (TIER1_ASSET_CATS.includes(assetCategoryIndex)) {
    tier = 1;
  } else if (TIER2_ASSET_CATS.includes(assetCategoryIndex)) {
    tier = 2;
  } else if (TIER3_ASSET_CATS.includes(assetCategoryIndex)) {
    tier = 3;
  } else if (TIER4_ASSET_CATS.includes(assetCategoryIndex)) {
    tier = 4;
  }
  if (docCriteria === 'FAST DOC') {
    if ((tier === 1 || tier === 2) && isAssetBacked) {
      return 250000;
    } else if ((tier === 1 || tier === 2) && !isAssetBacked) {
      return 120000;
    } else if ((tier === 3 || tier === 4) && isAssetBacked) {
      return 200000;
    } else if ((tier === 3 || tier === 4) && !isAssetBacked) {
      return 120000;
    }
  } else if (docCriteria === 'EASY DOC') {
    if ((tier === 1 || tier === 2) && isAssetBacked) {
      return 500000;
    } else if ((tier === 1 || tier === 2) && !isAssetBacked) {
      return 200000;
    } else if ((tier === 3 || tier === 4) && isAssetBacked) {
      return 300000;
    } else if ((tier === 3 || tier === 4) && !isAssetBacked) {
      return 200000;
    }
  } else {
    if ((tier === 1 || tier === 2) && isAssetBacked) {
      return 1000000;
    } else if ((tier === 1 || tier === 2) && !isAssetBacked) {
      return 250000;
    } else if ((tier === 3 || tier === 4) && isAssetBacked) {
      return 500000;
    } else if ((tier === 3 || tier === 4) && !isAssetBacked) {
      return 250000;
    }
  }
  return 250000;
}


export const minDepositForPricingConsumerAssetFinance = (isCreditOrAdmin: boolean, invoiceAmount: number, assetTypeIndex: string, isPropertyOwner: boolean): number | null => {
  if (isCreditOrAdmin) {
    return 0;
  }
  return minDepositForConsumerAssetFinance(invoiceAmount, assetTypeIndex, isPropertyOwner);
}

export const minDepositForConsumerAssetFinance = (invoiceAmount: number, assetTypeIndex: string, isPropertyOwner: boolean): number | null => {
  const isCar = isConsumerAssetForCar(assetTypeIndex);

  const apply20pDeposit = isCar && invoiceAmount > 75000 && !isPropertyOwner;

  if (apply20pDeposit) {
    const minDeposit = _.round(invoiceAmount * 0.2, 2); // 20% of invoiceAmount
    return minDeposit;
  } else {
    return 0;
  }
}

export const minDepositForSolar = (invoiceAmount: number, isPropertyOwner: boolean): number | null => {
  const apply20pDeposit = !isPropertyOwner;

  if (apply20pDeposit) {
    const minDeposit = _.round(invoiceAmount * 0.2, 2); //20% of invoiceAmount
    return minDeposit;
  } else {
    return 0;
  }
}

export const maxLoanForBusinessLoan = (gstAge: number, PropertyOwner: boolean | null): number => {
  if (PropertyOwner) {
    if (gstAge >= 24) {
      return 500000;
    } else {
      return 250000;
    }
  } else {
    return 100000;
  }
}

export const maxLoanForBusinessOverdraft = (gstAge: number, PropertyOwner: boolean | null): number => {
  if (PropertyOwner) {
    if (gstAge >= 24) {
      return 500000;
    } else {
      return 250000;
    }
  } else {
    return 100000;
  }
}



// ===========================================
// === auth / user / customer
// ===========================================
export const isInternalUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    ['admin', 'analyst', 'internalbroker', 'operations', 'operations24', 'credit', 'salesBDM', 'salesAM'].includes(u.AccessLevel));
}

export const isNotAdminOrCreditOrSalesAMInternalUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return !(isCreditUser(u) || isAdmin(u) || isSalesAM(u));
}

export const isCreditUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    ['credit'].includes(u.AccessLevel));
}

export const isAdminOrCreditUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isCreditUser(u) || isAdmin(u);
}

export const isAdminOrOperationUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isOperations(u) || isAdmin(u);
}

export const isAdminOrCreditUserOrSalesAM = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isCreditUser(u) || isAdmin(u) || isSalesAM(u);
}

export const isAdminOrCreditOrOperationsOrSalesUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isCreditUser(u) || isAdmin(u) || isSalesAM(u) || isSalesBDM(u) || isOperations(u);
}

export const isAdminOrSalesUser = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isAdmin(u) || isExternalAdmin(u) || isSalesBDM(u) || isSalesAM(u);
}

export const isAdminOrOperationsOrAnalyst = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isAdmin(u) || isOperations(u) || isAnalyst(u);
}

export const isAdminOrFinance = (u?: Pick<UserandPriviledges, 'AccessLevel'> | null): boolean => {
  return isAdmin(u) || isFinance(u);
}

export const isOperations = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    u.AccessLevel == 'operations');
}

export const isOperations24 = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    u.AccessLevel == 'operations24');
}

export const isAdmin = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    u.AccessLevel == 'admin');
}

export const isSalesAM = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    u.AccessLevel == 'salesAM');
}

export const isSalesBDM = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    u.AccessLevel == 'salesBDM');
}

export const isAnalyst = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    (u.AccessLevel == 'analyst' || u.AccessLevel == 'operations' || u.AccessLevel == 'operations24' || u.AccessLevel == 'credit'));
}

export const isFinance = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    u.AccessLevel == 'analyst');
}

export const isDealer = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    ['dealer'].includes(u.AccessLevel));
}

export const isExternalUser = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    ['externalbroker', 'companyadmin', 'companyoperator'].includes(u.AccessLevel));
}

export const isExternalBroker = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    ['externalbroker'].includes(u.AccessLevel));
}

export const isExternalAdmin = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel &&
    ['companyadmin'].includes(u.AccessLevel));
}

export const isInternalUserOrBroker = (u?: Pick<UserandPriviledges, 'priviledges'> | null): boolean => {
  return (!!u &&
    !!u.priviledges && (
      u.priviledges?.includes('admin') ||
      u.priviledges?.includes('analyst') ||
      u.priviledges?.includes('internalbroker') ||
      u.priviledges?.includes('externalbroker') ||
      u.priviledges?.includes('broker') ||
      u.priviledges?.includes('companyadmin') ||
      u.priviledges?.includes('operations') ||
      u.priviledges?.includes('operations24') ||
      u.priviledges?.includes('credit') ||
      u.priviledges?.includes('salesBDM') ||
      u.priviledges?.includes('salesAM')
    )
  )
}

export const isNonSalesInternalUser = (u?: Pick<User, 'AccessLevel'> | null): boolean => {
  return (!!u &&
    !!u.AccessLevel && (
      u.AccessLevel == 'admin' ||
      u.AccessLevel == 'analyst' ||
      u.AccessLevel == 'internalbroker' ||
      u.AccessLevel == 'operations' ||
      u.AccessLevel == 'operations24' ||
      u.AccessLevel == 'credit'
    )
  )
}

export const isAssociatedWithAggregator = (u?: Pick<UserandPriviledges, 'priviledges'> | null): boolean => {
  return (!!u && u.priviledges.includes('aggregator'));
}

export const toUser = <T extends User>(user: T | null, removeSensitiveInfo: boolean = true): T | null => {
  if (user) {
    if (removeSensitiveInfo) {
      delete (user as any).PasswordHash;
      delete (user as any).PasswordSalt;
    }
    if (user.ResidentialAddress) {
      user.ResidentialAddress = parseJSON(user.ResidentialAddress);
    }
    if (user.PostalAddress) {
      user.PostalAddress = parseJSON(user.PostalAddress);
    }
    if (user.RoleAccess) {
      user.RoleAccess = parseJSON(user.RoleAccess);
    }
    if (user.kycVerificationResult) {
      user.kycVerificationResult = parseJSON(user.kycVerificationResult);
    }
    if (user.kycVerificationError) {
      user.kycVerificationError = parseJSON(user.kycVerificationError);
    }
  }
  return user;
}

export const toCustomer = <T extends Customer>(customer: T): T => {
  if (customer) {
    if (customer.CustomerId) {
      customer.CustomerId = Array.isArray(customer.CustomerId) ? customer.CustomerId.filter(c => !!c)[0] : customer.CustomerId;
    }
    if (customer.Address) {
      customer.Address = parseJSON(customer.Address);
    }
    if (customer.Document) {
      customer.Document = parseJSON(customer.Document);
    }
  }
  return customer;
}

/* export const toDrawdownRequest = <T extends DrawdownRequest | PendingDrawdown2 | ApprovedDrawdown2>(d: T): T => {
  if (d) {
    if (d.shipment) {
      d.shipment = parseJSON(d.shipment);
      if (d.shipment) {
        d.shipment.preship = !!d.shipment.preship;
        d.shipment.postship = !!d.shipment.postship;
      }
    }
    if (d.shipmentDetails) {
      d.shipmentDetails = parseJSON(d.shipmentDetails);
    }
    if (d.authoriseDetails) {
      d.authoriseDetails = parseJSON(d.authoriseDetails);
    }
    if (d.disbursementInstructions) {
      d.disbursementInstructions = parseJSON(d.disbursementInstructions);
    }

    if ((d as (PendingDrawdown2 | ApprovedDrawdown2)).Address) {
      (d as (PendingDrawdown2 | ApprovedDrawdown2)).Address = parseJSON((d as (PendingDrawdown2 | ApprovedDrawdown2)).Address);
    }
    if (d.supportingDoc) {
      d.supportingDoc = parseJSON(d.supportingDoc);
    }
    if ((d as (PendingDrawdown2 | ApprovedDrawdown2)).Address) {
      (d as (PendingDrawdown2 | ApprovedDrawdown2)).Address = parseJSON((d as (PendingDrawdown2 | ApprovedDrawdown2)).Address);
    }

  }
  return d;
} */

export const toRatecardDetails = <T extends RatecardDetails>(_r: T, rbaRate: number): T => {
  if (_r) {
    let assetTypes: AssetTypeRateValue = parseJSON(_r.AssetType);
    if (assetTypes && Array.isArray(assetTypes)) {
      assetTypes = assetTypes.map(assetType => ({
        Cat: assetType.Cat,
        Type: assetType.Type.split('-')[1] ?? assetType.Type,
        Rate: assetType.Rate,
      }))
    }
    _r.AssetType = assetTypes ?? [];
    _r.ABNorGSTAge = parseJSON(_r.ABNorGSTAge);
    _r.ApplicationCategory = parseJSON(_r.ApplicationCategory);
    _r.AssetFinanceTier1 = parseJSON(_r.AssetFinanceTier1);
    _r.AssetFinanceTier2 = parseJSON(_r.AssetFinanceTier2);
    _r.AssetFinanceTier3 = parseJSON(_r.AssetFinanceTier3);
    _r.AssetFinanceTier4 = parseJSON(_r.AssetFinanceTier4);
    _r.TransactionTypeRate = parseJSON(_r.TransactionTypeRate);
    _r.AssetCategory = parseJSON(_r.AssetCategory);
    _r.Brokerage = parseJSON(_r.Brokerage);
    _r.DocFee = parseJSON(_r.DocFee);
    _r.EOTAge = parseJSON(_r.EOTAge);
    _r.LoanAmount = parseJSON(_r.LoanAmount);
    _r.LoanTerms = parseJSON(_r.LoanTerms);
    _r.CarsAndCaravans = parseJSON(_r.CarsAndCaravans);
    _r.Motorbikes = parseJSON(_r.Motorbikes);
    _r.SolarSystems = parseJSON(_r.SolarSystems);
    _r.SecurityType = parseJSON(_r.SecurityType);
    _r.Tiers = parseJSON((_r as any).Tiers);
    _r.rbaRate = rbaRate;
  }
  return _r;
}


export const toApplication = <T extends Application>(r: T): T => {
  if (r) {
    (r as any).ApplicantLocation = parseJSON((r as any).ApplicantLocation);
    (r as any).CompanyDetails = parseJSON((r as any).CompanyDetails);
    (r as any).AppInfo = parseJSON((r as any).AppInfo);
    if ((r as any)?.AppInfo?.LoanPurpose) {
      (r as any).AppInfo.LoanPurpose = parseJSON((r as any).AppInfo?.LoanPurpose ?? undefined);
    }
    (r as any).Contacts = parseJSON((r as any).Contacts);
    // Retired columns (AZ-1475): no longer written, so whatever they hold is stale. Parties come from
    // attachApplicationParties.
    delete (r as any).CommercialEntities;
    delete (r as any).Individuals;
    (r as any).Reference = parseJSON((r as any).Reference);
    (r as any).AssetSpec = parseJSON((r as any).AssetSpec);
    (r as any).Expense = parseJSON((r as any).Expense);
    (r as any).Policies = parseJSON((r as any).Policies);
    (r as any).PricingDetails = parseJSON((r as any).PricingDetails);
    (r as any).Documents = parseJSON((r as any).Documents);
    (r as any).InteflowStatus = parseJSON((r as any).InteflowStatus);
    (r as any).DocumentResult = parseJSON((r as any).DocumentResult);
    (r as any).GrowRiskRatingData = parseJSON((r as any).GrowRiskRatingData);
    (r as any).OppStatus = parseJSON((r as any).OppStatus);
    (r as any).AdditionalBrokerCorrespondent = parseJSON((r as any).AdditionalBrokerCorrespondent);
    (r as any).BrokerContact = parseJSON((r as any).BrokerContact);
    (r as any).LvrCalculatorValue = parseJSON((r as any).LvrCalculatorValue);
    (r as any).DscrCalculatorValue = parseJSON((r as any).DscrCalculatorValue);
    (r as any).ConsumerDscrCalculatorValue = parseJSON((r as any).ConsumerDscrCalculatorValue);
    (r as any).PreviousBusiness = parseJSON((r as any).PreviousBusiness);
    (r as any).AssociatedEntities = parseJSON((r as any).AssociatedEntities) ?? [];
    (r as any).CreditApprovedDetails = parseJSON((r as any).CreditApprovedDetails);
    (r as any).CreditDeclineDetails = parseJSON((r as any).CreditDeclineDetails);

    if ((r as any).DocumentResult) {
      for (const dRst of (r as any).DocumentResult) {
        if (dRst.result) {
          dRst.result = parseJSON(dRst.result);
        }
      }
    }
    (r as any).AuthorisedSignatory = parseJSON((r as any).AuthorisedSignatory);
    (r as any).Policies = parseJSON((r as any).Policies);
    (r as any).DocumentTypes = parseJSON((r as any).DocumentTypes);
  }
  return r;
}


export const toPpsrData = <T extends PpsrData>(r: T): T => {
  if (r) {
    if (r.PPSRResponse) {
      r.PPSRResponse = parseJSON(r.PPSRResponse);
    }
    if (r.companySummary) {
      r.companySummary = parseJSON(r.companySummary);
    }
    if (r.Grantors) {
      r.Grantors = (parseJSON(r.Grantors) ?? [])
        .map((g: PpsrData['Grantors']) => {
          if ((g as any).OrganisationNumberType && (g as any).OrganisationNumberType == 'ABN') {
            return {
              type: 'ABN',
              ...g,
            }
          } else if ((g as any).OrganisationNumberType && (g as any).OrganisationNumberType == 'ACN') {
            return {
              type: 'ACN',
              ...g,
            }
          } else {
            return {
              type: 'Individual',
              ...g,
            }
          }
        });
    }
  }
  return r;
}

export const toPpsrAsset = <T extends PpsrAsset>(r: T): T => {
  if (r) {
    if (r.AssetSFRes) {
      r.AssetSFRes = parseJSON(r.AssetSFRes);
    }
    if (r.SettlementAssetDetails) {
      r.SettlementAssetDetails = parseJSON(r.SettlementAssetDetails);
    }
    if (r.PrivateSellerDetails) {
      r.PrivateSellerDetails = parseJSON(r.PrivateSellerDetails);
    }
  }
  return r;
}






// =========================
// === driver licence
// =========================

export const isDriverLicenceDetailsError = (driverLicence: DriverLicenceDetails): driverLicence is DriverLicenceDetailsError => {
  return (driverLicence as any).Error;
}


// ==============================
// ==== Access Level
// ==============================
export const allowEmailAccessLevel = (email: string, accessLevel: AccessLevel): boolean => {
  const isInternalEmail = INTERNAL_EMAIL_DOMAINS.reduce((acc, currentEmailDomain) => {
    const r = (email ?? '').trim().toLowerCase().endsWith(currentEmailDomain);
    const x = (acc || r);
    return x;
  }, false);
  const isInternalAccess = INTERNAL_ACCESS_LEVEL.reduce((acc, currentAccessLevel) => {
    const r = ((accessLevel ?? '').trim().toLowerCase() == currentAccessLevel.toLowerCase());
    const x = (acc || r);
    return x;
  }, false);
  if (isInternalEmail) {
    return true;
  }
  return !isInternalAccess;
}

// ==============================
// ==== Contract
// ==============================
export const getCustomerName = (application: Application): string => {
  const applicationType = application.ApplicationType;
  let customerName = '';
  if (applicationType === 'Consumer') {
    const applicant = applicantOf(application.parties);
    customerName = (applicant?.givenName ?? "") + " " + (applicant?.surname ?? "");
  } else {
    const primaryEntity = primaryEntityOf(application.parties);
    customerName = primaryEntity?.legalName ?? "";
  }
  return customerName;
}

export const getContractFileName = (application: Application): string => {
  const applicationType = application.ApplicationType;
  let fileName = '';
  const customerName = getCustomerName(application);
  switch (applicationType) {
    case 'AssetFinance':
      const financeType = application.AppInfo?.FinanceType;
      if (financeType === "Chattel Mortgage") {
        fileName = constants.contractTemplates.chattelMortgage;
      } else {
        fileName = constants.contractTemplates.rental;
      }
      break;
    case 'Consumer':
      fileName = constants.contractTemplates.consumer;
      break;
    case 'BusinessLoans':
      fileName = constants.contractTemplates.businessLoans;
      break;
    case 'BusinessOverdraft':
      fileName = constants.contractTemplates.businessOverdraft;
      break;
    case 'CorporateLoans':
      fileName = constants.contractTemplates.corporateLoans;
      break;
    default:
      fileName = constants.contractTemplates.default;
  }

  fileName = fileName.slice(0, fileName.length - 5);
  fileName = fileName + " for " + customerName + " " + (application?.BrokerAppId ?? " ") + ".pdf";

  return fileName;
}

export const getApprovalNoticeFileName = (application: Application): string => {
  const customerName = getCustomerName(application);
  return `Approval Notice For ${customerName} (${application.BrokerAppId}).pdf`;
}

// ==============================
// ==== Numbers
// ==============================
export const getLocaleNumber = (a: number | string): string => {
  return numeral(a).format('0,0.00');
}

// ========================================================
// === Accreditation
// ========================================================
export const getAccreditationNumber = (accreditationId: number): NextAccreditationNumber => {
  const nextAccreditationNumber = accreditationId;
  const nextApplicantNumber = `A${String(100000 + nextAccreditationNumber).substring(1)}`;
  const accreditationNumber: NextAccreditationNumber = {
    accreditationNumber: nextAccreditationNumber,
    applicantNumber: nextApplicantNumber,
  };
  return accreditationNumber;
}

// ========================================================
// === Disbursement & Asset
// ========================================================
export const validateDisbursementData = (disbursementData: Disbursement[]): boolean => {
  for (const data of disbursementData) {
    if (!data?.bankDetails || !data?.bankDetails?.paymentType) {
      return false;
    }
  }
  return true;
}

export const calculateTotalAssetDeposit = (assets: {
  SettlementAssetDetails?: {
    depositAmountDynamoney?: number,
    depositAmountSupplier?: number,
  } | null,
}[]) => {
  const { totalDepositAmountDyna, totalDepositAmountSupplier } = (assets ?? []).reduce((acc, asset) => {
    const _totalDepositAmountDyna = (acc.totalDepositAmountDyna +
      (asset.SettlementAssetDetails?.depositAmountDynamoney ?? 0));
    const _totalDepositAmountSupplier = (acc.totalDepositAmountSupplier +
      (asset.SettlementAssetDetails?.depositAmountSupplier ?? 0));
    return {
      totalDepositAmountDyna: _totalDepositAmountDyna,
      totalDepositAmountSupplier: _totalDepositAmountSupplier
    };
  }, { totalDepositAmountDyna: 0, totalDepositAmountSupplier: 0 });
  return {
    totalDepositAmountDyna, totalDepositAmountSupplier
  };
}

// WEB-3702
export const validateAssetDepositAgainstApplicationDeposit = (applicationDeposit: number, assets: PpsrAsset[]): {
  totalDeposit: number,
  applicationDeposit: number,
  valid: boolean,
} => {
  const { totalDepositAmountDyna, totalDepositAmountSupplier } = calculateTotalAssetDeposit(assets);
  const totalDeposit = _.round(totalDepositAmountDyna + totalDepositAmountSupplier, 2);
  return {
    totalDeposit,
    applicationDeposit,
    valid: applicationDeposit == totalDeposit,
  };
}

// WEB-3702
export const validateAssetDeposits = (assets: PpsrAsset[]): {
  messages: string[],
  valid: boolean
} => {
  return (assets ?? []).reduce((acc: { messages: string[], valid: boolean }, asset) => {
    const total = (asset.SettlementAssetDetails?.depositAmountSupplier ?? 0) + (asset.SettlementAssetDetails?.depositAmountDynamoney ?? 0);
    if (total != asset.SettlementAssetDetails?.depositAmount) {
      acc.valid = false;
      acc.messages.push(`Asset ${asset.SettlementAssetDetails?.serialNumber ?? ''} deposit $${asset.SettlementAssetDetails?.depositAmount ?? 0} does not add up to the sum of deposit (dynamoney) $${asset.SettlementAssetDetails?.depositAmountDynamoney ?? 0} and deposit (Supplier) $${asset.SettlementAssetDetails?.depositAmountSupplier ?? 0}`);
    }
    return acc;
  }, {
    messages: [],
    valid: true,
  });
}

// ========================================================
// === Banking
// ========================================================
export const getReversalProcessingCode = (processingCode: PismoTransactionProcessingCode): PismoTransactionProcessingCode => {
  switch (processingCode) {
    case PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER:
      return PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER_REVERSAL;
    case PismoTransactionProcessingCode.BPAY:
      return PismoTransactionProcessingCode.BPAY_REVERSAL;
    case PismoTransactionProcessingCode.DOCUMENTATION_FEE:
      return PismoTransactionProcessingCode.PAYMENT;
    case PismoTransactionProcessingCode.FACILITY_FEE:
      return PismoTransactionProcessingCode.FACILITY_FEE_REVERSAL;
    case PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE:
      return PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE_REVERSAL;
    default:
      return PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER_REVERSAL;
  }
}

export const getProcessingType = (processingCode: PismoTransactionProcessingCode): string => {
  switch (processingCode) {
    case PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER:
      return 'Bank Transfer';
    case PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER_REVERSAL:
      return 'Bank Transfer Reversal';
    case PismoTransactionProcessingCode.BPAY:
      return 'BPAY';
    case PismoTransactionProcessingCode.BPAY_REVERSAL:
      return 'BPAY Reversal';
    case PismoTransactionProcessingCode.DOCUMENTATION_FEE:
      return 'Documentation Fee';
    case PismoTransactionProcessingCode.FACILITY_FEE:
      return 'Facility Fee';
    case PismoTransactionProcessingCode.FACILITY_FEE_REVERSAL:
      return 'Facility Fee Reversal';
    case PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE:
      return 'Facility Establishment Fee';
    case PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE_REVERSAL:
      return 'Facility Establishment Fee Reversal';
    case PismoTransactionProcessingCode.BROKERAGE:
      return 'Brokerage';
    case PismoTransactionProcessingCode.PAYMENT:
      return 'Payment';
    case PismoTransactionProcessingCode.PAYMENT_REVERSAL:
      return 'Payment Reversal';
    case PismoTransactionProcessingCode.ANNUAL_FEE:
      return 'Annual Fee';
    case PismoTransactionProcessingCode.ANNUAL_FEE_REVERSAL:
      return 'Annual Fee Reversal';
    case PismoTransactionProcessingCode.MERCHANT:
      return 'Merchant';
    case PismoTransactionProcessingCode.DOCUMENTATION_FEE_REVERSAL:
    case PismoTransactionProcessingCode.DOCUMENTATION_FEE:
      return 'Documentation Fee';
    case PismoTransactionProcessingCode.PAYOUT:
      return 'Payout';
    case PismoTransactionProcessingCode.PAYOUT_REVERSAL:
      return 'Payout Reversal';
    default:
      return processingCode;
  }
}

// ========================================================
// === Pismo
// ========================================================
export const encodePismoAddress = (address: Address2ComponentValue | undefined, firstName: string, businessName: string): string => {
  if (address) {
    const addrLine = address.UnitNumber ? `${address.UnitNumber}/${address.StreetNumber ?? ""} ${address.StreetName ?? ""} ${address.StreetType ?? ""}` :
      `${address.StreetNumber ?? ""} ${address.StreetName ?? ""} ${address.StreetType ?? ""}`;
    return `FIRSTNAME:${firstName};BUSNAME:${businessName};ADDRLINE:${addrLine};LOC:${address.Suburb ?? ""};` +
      `STATE:${address.State ?? ""};POSTCODE:${address.Postcode ?? ""};COUNTRY:AUSTRALIA;PRODUCTTYPE:DEFAULT`;
  } else {
    return `FIRSTNAME:${firstName};BUSNAME:${businessName};ADDRLINE:;LOC:;STATE:;POSTCODE:;COUNTRY:AUSTRALIA;PRODUCTTYPE:DEFAULT`;
  }
}

export const decodePismoAddress = (addressString: string): Address2ComponentValue => {
  const splits = addressString.split(';');
  if (addressString && splits.length) {
    let streetNumber = "", streetName = "", streetType = "", suburb = "", state = "", unitNumber = "", postcode = "";
    for (const split of splits) {
      if (split.startsWith("STNO:")) {
        streetNumber = split.slice(5, split.length);
      } else if (split.startsWith("STNAME:")) {
        const streetNameAndType = split.slice(7, split.length);
        const streetNameAndTypeSplits = streetNameAndType.split(" ");
        if (streetNameAndTypeSplits.length > 1) {
          streetType = streetNameAndTypeSplits[streetNameAndTypeSplits.length - 1];
          streetName = streetNameAndTypeSplits.slice(0, streetNameAndTypeSplits.length - 1).join(" ");
        } else {
          streetName = streetNameAndType;
        }
      } else if (split.startsWith("LOC:")) {
        suburb = split.slice(4, split.length);
      } else if (split.startsWith("STATE:")) {
        state = split.slice(6, split.length);
      } else if (split.startsWith("POSTCODE:")) {
        postcode = split.slice(9, split.length);
      }
    }
    return {
      address: `${streetNumber} ${streetName} ${streetType}, ${suburb}, ${state} ${postcode}`,
      StreetNumber: streetNumber,
      StreetName: streetName,
      StreetType: streetType,
      Suburb: suburb,
      State: state,
      UnitNumber: unitNumber,
      Postcode: postcode,
    }
  } else {
    return null;
  }
}

export const pismoPhoneNumber = (phoneNumber: string): PismoPhoneBody => {
  return {
    number: phoneNumber.substring(2), // remove 04 from phone number
    type: "MOBILE",
    extension: null!,
    active: true,
    country_code: '61',
    area_code: '4'
  }
}

export const validateMobileNumber = (phoneNumber: string): boolean => {
  return phoneNumber.startsWith('04') && phoneNumber.length === 10;
}

export const patchFlexControlBody = (flexControl: PismoFlexControlBody): PismoFlexControlBody => {
  if (flexControl?.max_limit != undefined) {
    return {
      ...flexControl,
      max_limit: _.round(flexControl.max_limit * 100, 2)
    }
  }
  return flexControl;
}

export const patchFlexControlResponse = (flexControl: PismoFlexControlResponse): PismoFlexControlResponse => {
  if (flexControl?.max_limit != undefined) {
    return {
      ...flexControl,
      max_limit: Math.round(flexControl.max_limit) / 100,
      available_limit: Math.round(flexControl.available_limit) / 100
    }
  }
  return flexControl;
}

export const getTransactionPricipalAmount = (transaction: PismoTransaction): number => {
  const amountObj = transaction.amount.find(obj => obj.type === 'PRINCIPAL');
  if (amountObj) {
    return amountObj.value;
  }
  return 0;
}

export const convertBankingTransactionToPismoPendingTransaction = (transaction: PismoBankingTransaction): PismoPendingTransaction => {
  return {
    type: 'Pending Payments',
    account_id: transaction.PismoAccountId,
    category: 'payment',
    tenant_account_timestamp: '',
    data: {
      item: {
        contract_amount: transaction.amount,
        response_code: '',
        validation_results: [],
        merchant_city: '',
        dcc: true,
        org_operation: {
          processing_code: transaction.processingCode
        },
        program_id: 0,
        entry_mode: '',
        number_of_installments: 1,
        principal_amount: transaction.amount,
        settlement_currency_literal: '',
        currency_code: '036',
        cardholderbilling_amount: 0,
        ledger_update_id: '',
        settlement_currency_code: '036',
        network: '',
        pre_authorization: false,
        merchant_category_group: '',
        soft_descriptor:
          transaction.processingCode === PismoTransactionProcessingCode.BPAY ?
            `BPAY to ${transaction.accountTitle}(BillerCode: ${transaction.billerCode} CRN: ${transaction.crn})` :
            transaction.processingCode === PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER ?
              `Bank Transfer to ${transaction.accountTitle} (BSB: ${transaction.bsb}, AccNo: ${transaction.accountNumber})` :
              transaction.processingCode === PismoTransactionProcessingCode.PAYOUT ?
                `Payout to ${transaction.accountTitle}` :
                `Overdraft Payment from ${transaction.accountTitle} (BSB: ${transaction.bsb}, AccNo: ${transaction.accountNumber})`,
        installments: [{
          date: transaction.date,
          amount: transaction.amount,
        }],
        currency_literal: '',
        authorization_code: '',
        cash_back_amount: 0,
        airport_tax: 0,
        interest_rate: 0,
        postings: [],
        id: transaction.id,
        mti: '',
        installment_amount: 0,
        to_name: '',
        merchant_category_code: '',
        rates: {
          conversion_rate: 0,
          cardholder_conversion_rate: 0,
          intl_purchase_fx_rate: 0
        },
        settlement_currency_rate: 0,
        merchant_state_or_country: '',
        card_type: '',
        card_id: 0,
        cardholder_currency_rate: 0,
        local_amount: transaction.amount,
        card_name: '',
        entry_mode_literal: '',
        customer_id: transaction.PismoCustomerId,
        settlement_currency_amount: 0
      }
    },
    correlation_id: `${transaction.id}`,
    timestamp: transaction.createdTime ?? '',
    processing_code: transaction.processingCode,
    metadata: {
      OD_PAYMENT_TIME: transaction.createdTime,
      OD_PAYMENT_COLLECTED_BY: "DYNAMONEY MOBILE",
      AccountName: transaction.accountTitle ?? '',
      BSB: transaction.bsb ?? '',
      AccountNumber: transaction.accountNumber ?? '',
      CRN: transaction.crn ?? '',
      BillerCode: transaction.billerCode ?? '',
      Description: transaction.reference ?? ''
    }
  }
}

export const getPismoAccountingRecordCategory = (record: PismoAccountingRecord): PismoAccountingCategory => {
  if ([
    PismoTransactionProcessingCode.DOCUMENTATION_FEE,
    PismoTransactionProcessingCode.DOCUMENTATION_FEE_REVERSAL,
    PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE,
    PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE_REVERSAL,
    PismoTransactionProcessingCode.FACILITY_FEE,
    PismoTransactionProcessingCode.FACILITY_FEE_REVERSAL,
    PismoTransactionProcessingCode.CARD_REISSUE_FEE,
    PismoTransactionProcessingCode.CARD_REISSUE_FEE_REVERSAL,
    PismoTransactionProcessingCode.PAYMENT_DISHONOUR_FEE,
    PismoTransactionProcessingCode.PAYMENT_DISHONOUR_FEE_REVERSAL,
    PismoTransactionProcessingCode.LATE_FEE,
    PismoTransactionProcessingCode.CAN_LATE_FEE,
    PismoTransactionProcessingCode.UNDO_CANC_LATE_FEE,
    PismoTransactionProcessingCode.OVERLIMIT_FEE,
    PismoTransactionProcessingCode.CAN_OVERLIMIT_FEE,
    PismoTransactionProcessingCode.UNDO_CANC_OVERLIMIT_FEE,
    PismoTransactionProcessingCode.ANNUAL_FEE,
    PismoTransactionProcessingCode.ANNUAL_FEE_REVERSAL,
    PismoTransactionProcessingCode.ANNUITY,
    PismoTransactionProcessingCode.CAN_ANNUITY,
    PismoTransactionProcessingCode.SECURITY_REGISTRATION_AND_LEGAL_FEE,
    PismoTransactionProcessingCode.SECURITY_REGISTRATION_AND_LEGAL_FEE_REVERSAL,
    PismoTransactionProcessingCode.UNPAID_FACILITY_FEE,
    PismoTransactionProcessingCode.UNPAID_FACILITY_FEE_REVERSAL,
  ].includes(record.processingCode)) {
    return 'fees';
  } else if ([
    PismoTransactionProcessingCode.INSTALLMENT_WITHOUT_INTEREST,
    PismoTransactionProcessingCode.INSTALLMENT_WITHOUT_INTEREST_REVERSAL,
    PismoTransactionProcessingCode.INTEREST,
    PismoTransactionProcessingCode.INTEREST_REVERSAL,
    PismoTransactionProcessingCode.INTEREST_ON_REVOLVING_CREDIT,
    PismoTransactionProcessingCode.INTEREST_ON_REVOLVING_CREDIT_REVERSAL,
    PismoTransactionProcessingCode.UNDO_CANC_INTEREST_ON_REVOLVING_CREDIT,
    PismoTransactionProcessingCode.LATE_PAYMENT_INTEREST,
    PismoTransactionProcessingCode.CAN_LATE_PAYMENT_INTEREST,
    PismoTransactionProcessingCode.UNDO_CANC_LATE_PAYMENT_INTEREST
  ].includes(record.processingCode)) {
    return 'interest';
  } else if ((record.processingCode === PismoTransactionProcessingCode.PAYMENT && record.description === 'Payment') ||
    record.processingCode === PismoTransactionProcessingCode.MINIMUM_PAYMENT_REVERSAL
  ) {
    return 'systemRepayment'
  } else if (
    (record.processingCode === PismoTransactionProcessingCode.PAYMENT && record.description === 'Manual Payment') ||
    record.processingCode === PismoTransactionProcessingCode.PAYMENT_REVERSAL
  ) {
    return 'manualRepayment'
  } else if ([
    PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER,
    PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER_REVERSAL,
    PismoTransactionProcessingCode.BPAY,
    PismoTransactionProcessingCode.BPAY_REVERSAL,
    PismoTransactionProcessingCode.PAYOUT,
    PismoTransactionProcessingCode.PAYOUT_REVERSAL
  ].includes(record.processingCode)) {
    return 'redrawWithTheBank';
  } else if ([
    PismoTransactionProcessingCode.TRANSFERRED_BALANCE,
    PismoTransactionProcessingCode.TRANSFERRED_BALANCE_REVERSAL,
  ].includes(record.processingCode)) {
    return 'others';
  } else if ([
    PismoTransactionProcessingCode.CREDIT_ADJUSTMENT
  ].includes(record.processingCode)) {
    return 'creditAdjustment'
  } else if ([
    PismoTransactionProcessingCode.DEBIT_ADJUSTMENT
  ].includes(record.processingCode)) {
    return 'debitAdjustment'
  } else {
    return 'creditCard';
  }
}

export const getTransactionTypeForOFX = (transaction: PismoTransaction): PismoTransactionTypeForOFX => {
  const processingCode = (transaction as PismoTransaction).processing_code
  if ([
    PismoTransactionProcessingCode.DOCUMENTATION_FEE,
    PismoTransactionProcessingCode.DOCUMENTATION_FEE_REVERSAL,
    PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE,
    PismoTransactionProcessingCode.FACILITY_ESTABLISHMENT_FEE_REVERSAL,
    PismoTransactionProcessingCode.FACILITY_FEE,
    PismoTransactionProcessingCode.FACILITY_FEE_REVERSAL,
    PismoTransactionProcessingCode.CARD_REISSUE_FEE,
    PismoTransactionProcessingCode.CARD_REISSUE_FEE_REVERSAL,
    PismoTransactionProcessingCode.PAYMENT_DISHONOUR_FEE,
    PismoTransactionProcessingCode.PAYMENT_DISHONOUR_FEE_REVERSAL,
    PismoTransactionProcessingCode.LATE_FEE,
    PismoTransactionProcessingCode.CAN_LATE_FEE,
    PismoTransactionProcessingCode.UNDO_CANC_LATE_FEE,
    PismoTransactionProcessingCode.OVERLIMIT_FEE,
    PismoTransactionProcessingCode.CAN_OVERLIMIT_FEE,
    PismoTransactionProcessingCode.UNDO_CANC_OVERLIMIT_FEE,
    PismoTransactionProcessingCode.ANNUAL_FEE,
    PismoTransactionProcessingCode.ANNUAL_FEE_REVERSAL,
    PismoTransactionProcessingCode.ANNUITY,
    PismoTransactionProcessingCode.CAN_ANNUITY,
    PismoTransactionProcessingCode.PAYOUT,
  ].includes(processingCode)) {
    return 'FEE';
  } else if ([
    PismoTransactionProcessingCode.INSTALLMENT_WITHOUT_INTEREST,
    PismoTransactionProcessingCode.INSTALLMENT_WITHOUT_INTEREST_REVERSAL,
    PismoTransactionProcessingCode.INTEREST,
    PismoTransactionProcessingCode.INTEREST_REVERSAL,
    PismoTransactionProcessingCode.INTEREST_ON_REVOLVING_CREDIT,
    PismoTransactionProcessingCode.INTEREST_ON_REVOLVING_CREDIT_REVERSAL,
    PismoTransactionProcessingCode.UNDO_CANC_INTEREST_ON_REVOLVING_CREDIT,
    PismoTransactionProcessingCode.LATE_PAYMENT_INTEREST,
    PismoTransactionProcessingCode.CAN_LATE_PAYMENT_INTEREST,
    PismoTransactionProcessingCode.UNDO_CANC_LATE_PAYMENT_INTEREST
  ].includes(processingCode)) {
    return 'INT';
  } else if ((
    processingCode === PismoTransactionProcessingCode.PAYMENT ||
    processingCode === PismoTransactionProcessingCode.MINIMUM_PAYMENT_REVERSAL ||
    processingCode === PismoTransactionProcessingCode.PAYMENT_REVERSAL)
  ) {
    return 'DEP'
  } else if ([
    PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER,
    PismoTransactionProcessingCode.EXTERNAL_BANK_TRANSFER_REVERSAL,
    PismoTransactionProcessingCode.BPAY,
    PismoTransactionProcessingCode.BPAY_REVERSAL,
  ].includes(processingCode)) {
    return 'PAYMENT';
  } else if (transaction.transaction_type.credit) {
    return 'CREDIT';
  } else {
    return 'DEBIT';
  }
}

export const getAccountBalance = (balances: PismoReportAccountsBalances[], accountId: number): number => {
  const filteredBalances = balances.filter(balance => balance.Account_ID === accountId);
  return filteredBalances.reduce((a, b) => a + Number(b.Balance), 0);
}

export const getAccountDailyBalance = (balances: PismoReportDailyBalances[], accountId: number): number => {
  const filteredBalances = balances.filter(balance => balance.Account_id === accountId);
  return _.round(filteredBalances.reduce((a, b) => a + Number(b.Balance), 0), 2);
}

export const displayCardReissueReason = (reason: PismoCardReIssueReason): string => {
  switch (reason.type) {
    case "BROKEN":
      return "Card is Damaged";
    case "CLIENT_ORDER":
      return "Card is Expired";
    case "LOST":
      return "Card is Lost";
    case "UNRECEIVED":
      return "I didn't Receive the Card";
    case "DAMAGED":
      return "Card isn't Working";
    case "THEFT":
      return "Card is Stolen";
    default:
      return reason.description;
  }
}

// creatinoDate: YYYY-MM-DD
export const getUnpaidFacilityFeeTerms = (creationDate: string, terms: number): number => {
  const creation = moment(creationDate);
  const daysInCreationMonth = creation.daysInMonth();
  const dateOfCreationMonth = creation.date();
  const endOfCreationMonth = creation.endOf('month');

  const today = moment();
  const hourOfToday = today.hour();
  const dateOfToday = today.date();
  const daysInThisMonth = today.daysInMonth();
  const endOfThisMonth = today.endOf('month');

  let chargedFacilityFeeThisMonth = false;
  if (daysInThisMonth === 29) {
    if (daysInThisMonth - dateOfToday <= 1) {
      // charged this month
      chargedFacilityFeeThisMonth = true;
    } else if (daysInThisMonth - dateOfToday == 2 && hourOfToday > 13) {
      chargedFacilityFeeThisMonth = true;
    }
  } else {
    if (daysInThisMonth - dateOfToday == 0) {
      // charged this month
      chargedFacilityFeeThisMonth = true;
    } else if (daysInThisMonth - dateOfToday == 1 && hourOfToday > 13) {
      chargedFacilityFeeThisMonth = true;
    }
  }

  // calculate terms
  const paidTerms =
    (daysInCreationMonth - dateOfCreationMonth + 1) / daysInCreationMonth +
    Math.round(endOfThisMonth.diff(endOfCreationMonth, 'months')) -
    (chargedFacilityFeeThisMonth ? 0 : 1);
  return Math.max(0, terms - paidTerms);
}

export const getUnpaidFacilityFee = (creationDate: string, terms: number, creditLimit: number, facilityFeePercentage: number): number => {
  return _.round(getUnpaidFacilityFeeTerms(creationDate, terms) * creditLimit * facilityFeePercentage / 1200, 2);
}


// =========================================================
// === Application Challenger LVR & DSCR Calculator     ====
// =========================================================

export const normaliseToMonthlyAmount = (paymentPeriodAmount: number, paymentPeriod: PaymentPeriodType): number => {
  switch (paymentPeriod) {
    case 'Monthly': {
      return paymentPeriodAmount;
    }
    case 'Weekly': {
      return (paymentPeriodAmount * 52 / 12);
    }
    case 'Fortnightly': {
      return (paymentPeriodAmount * 26 / 12);
    }
    case 'Quarterly': {
      // each quater is 3 months
      return paymentPeriodAmount / 3;
    }
  }
  return paymentPeriodAmount;
}

export const normaliseFromMonthyAmount = (monthlyAmount: number, paymentPeriod: PaymentPeriodType) => {
  switch (paymentPeriod) {
    case 'Monthly': {
      return monthlyAmount;
    }
    case 'Weekly': {
      return monthlyAmount / 4;
    }
    case 'Fortnightly': {
      return monthlyAmount / 2;
    }
    case 'Quarterly': {
      return monthlyAmount * 3;
    }
  }
  return monthlyAmount;
}

export const calcApplicationLvrCalculatorValue = (input: LvrCalculatorInput): LvrCalculatorValue => {
  const totalAssets = (input.assets ?? []).reduce((total, asset) => {
    const t = total + asset.value;
    return t;
  }, 0);

  const totalLiabilities = (input.liabilities ?? []).reduce((total, liability) => {
    const t = total + liability.value;
    return t;
  }, 0);

  let proposedLoan = input.proposedLoan;
  let currentLvr: number | null = (totalLiabilities / totalAssets) * 100;
  let proposedLvr: number | null = ((totalLiabilities + proposedLoan) / totalAssets) * 100;
  if (_.isNaN(currentLvr) || !_.isFinite(currentLvr)) {
    currentLvr = null;
  } else {
    currentLvr = _.round(currentLvr, 3);
  }
  if (_.isNaN(proposedLvr) || !_.isFinite(currentLvr)) {
    proposedLvr = null;
  } else {
    proposedLvr = _.round(proposedLvr, 3);
  }
  const v: LvrCalculatorValue = {
    ...input,
    totalAssets,
    totalLiabilities,
    proposedLoan,
    currentLvrPercent: currentLvr,
    proposedLvrPercent: proposedLvr,
  }
  return v;
}

export const calcApplicationDscrCalculatorValue = (input: DscrCalculatorInput): DscrCalculatorValue => {
  const marginAdoptedPercent = (input.industryEbitda?.percentage ?? 0) + input.adjustmentPercent
  const cashAvailableForDebtServiceMonthly = input.averageMonthlySalesAdopted * (marginAdoptedPercent / 100)
  const totalFinancingCommitmentsMonthly = input.existingDebtCommitmentsMonthly + input.atoPaymentPlanMonthly + input.additionalCommitments + input.proposedCommitmentsMonthly
  const debtServiceCoverRatio = cashAvailableForDebtServiceMonthly / totalFinancingCommitmentsMonthly
  const averageMonthlySalesAdoptedAfterAdjustment = input.averageMonthlySalesAdopted + input.salesAdjustment;
  const proposedLoanAmount = input.loanAmount / averageMonthlySalesAdoptedAfterAdjustment;
  const v: DscrCalculatorValue = {
    ...input,
    marginAdoptedPercent,
    cashAvailableForDebtServiceMonthly,
    totalFinancingCommitmentsMonthly,
    debtServiceCoverRatio,
    proposedLoanAmount
  }
  return v;
}

export const parseString = (text: string): string => {
  return (removeUnprintableChar(text) as string).trim().toLowerCase();
}

export const getDeviceType = (id: string): string | undefined => {
  const deviceTypes: DeviceType = {
    '00': 'Card',
    '01': 'Mobile Network Operator (MNO) controlled removable secure element (SIM or UICC) personalized for use with a mobile phone or smartphone',
    '02': 'Key Fob',
    '03': 'Watch using a contactless chip or a fixed (non-removable) secure element not controlled by the MNO',
    '04': 'Mobile Tag',
    '05': 'Wristband',
    '06': 'Mobile Phone Case or Sleeve',
    '07': 'Mobile phone or smartphone with a fixed (non-removable) secure element controlled by the MNO, for example, code division multiple access (CDMA)',
    '08': 'Removable secure element not controlled by the MNO, for example, memory card personalized for used with a mobile phone or smartphone',
    '09': 'Mobile Phone or smartphone with a fixed (non-removable) secure element not controlled by the MNO',
    '10': 'MNO controlled removable secure element (SIM or UICC) personalized for use with a tablet or e-book',
    '11': 'Tablet or e-book with a fixed (non-removable) secure element controlled by the MNO',
    '12': 'Removable secure element not controlled by the MNO, for example, memory card personalized for use with a tablet or e-book',
    '13': 'Tablet or e-book with fixed (non-removable) secure element not controlled by the MNO',
    '14': 'Mobile phone or smartphone with a payment application running in a host processor',
    '15': 'Tablet or e-book with a payment application running in a host processor',
    '16': 'Mobile phone or smartphone with a payment application running in the Trusted Execution Environment (TEE) of a host processor',
    '17': 'Tablet or e-book with a payment application running in the TEE of a host processor',
    '18': 'Watch with a payment application running in the TEE of a host processor',
    '19': 'Watch with a payment application running in a host processor',
    '20': 'Card',
    '21': 'Phone Mobile phone',
    '22': 'Tablet/e-reader Tablet computer or e-reader',
    '23': 'Watch/Wristband Watch or wristband, including a fitness band, smart strap, disposable band, watch add-on, and security/ID band',
    '24': 'Sticker',
    '25': 'PC PC or laptop',
    '26': 'Device Peripheral Mobile phone case or sleeve',
    '27': 'Tag Key fob or mobile tag',
    '28': 'Jewelry Ring, bracelet, necklace, and cuff links',
    '29': 'Fashion Accessory Handbag, bag charm, and glasses',
    '30': 'Garment Dress',
    '31': 'Domestic Appliance Refrigerator, washing machine',
    '32': 'Vehicle Vehicle, including vehicle attached devices',
    '33': 'Media/Gaming Device Media or gaming device, including a set top box, media player, and television',
    '34': 'Reserved for future form factors'
    // '35' - '99': Reserved for future form factors. Additional descriptions can be added here.
  };

  return deviceTypes[id];
}


// =========================================================================
// === Business and overdraft Preliminary Borrowing Estimation Calculator
// ==========================================================================
export type BusinessPreliminaryBorrowerEstimationInput = {
  monthlyTurnover: number,
  overdueAtoDebt: number,
  numOfMissedPayments: number,
  numOfNonBankCashflowLenders: number,
};
export type BusinessPreliminaryBorrowerEstimationResult = { type: 'failed', } | { type: 'success', min: number, max: number };
export const calcBusinessPreliminaryBorrowingEstimation = (opts: BusinessPreliminaryBorrowerEstimationInput): BusinessPreliminaryBorrowerEstimationResult => {
  const calculatedMax = opts.monthlyTurnover * 1.5;

  if (
    (opts.overdueAtoDebt > opts.monthlyTurnover) ||
    (opts.numOfMissedPayments > 3) ||
    (opts.numOfNonBankCashflowLenders > 1) ||
    (calculatedMax < constants.products.business.minBorrowing)
  ) {
    return {
      type: 'failed',
    }
  }

  const max = _.min([calculatedMax, constants.products.business.maxBorrowing])!;
  const min = (calculatedMax >= constants.products.overdraft.maxBorrowing) ?  // we capped it
    (max - 100000) :
    _.max([opts.monthlyTurnover, constants.products.business.minBorrowing])!;

  return {
    type: 'success',
    min,
    max
  };
}

export type OverdraftPreliminaryBorrowingEstimationInput = {
  monthlyTurnover: number,
  overdueAtoDebt: number,
  numOfMissedPayments: number,
  numOfNonBankCashflowLenders: number,
}
export type OverdraftPreliminaryBorrowingEstimationResult = { type: 'failed' } | { type: 'success', min: number, max: number };
export const calcOverdraftPreliminaryBorrowingEstimation = (opts: OverdraftPreliminaryBorrowingEstimationInput): OverdraftPreliminaryBorrowingEstimationResult => {
  const calculatedMax = (opts.monthlyTurnover * 1.5) - opts.overdueAtoDebt;

  if (
    (opts.overdueAtoDebt > opts.monthlyTurnover) ||
    (opts.numOfMissedPayments > 1) ||
    (opts.numOfNonBankCashflowLenders > 1) ||
    (calculatedMax < constants.products.business.minBorrowing)
  ) {
    return {
      type: 'failed',
    }
  }

  const max = _.min([calculatedMax, constants.products.overdraft.maxBorrowing])!;
  const min = (calculatedMax >= constants.products.overdraft.maxBorrowing) ?  // we capped it
    max - 100000 :
    _.max([opts.monthlyTurnover, constants.products.overdraft.minBorrowing])!;

  return {
    type: 'success',
    min,
    max
  };
}

// ==============================
// ==== Credit Rules
// ==============================
export const extractSingleDataTypeFromText = (text: string): string | number | boolean => {
  const trimmedText = text.trim();
  if (!trimmedText.startsWith("'") && !trimmedText.startsWith('"')) {
    if (trimmedText.toLowerCase() === 'true') {
      return true;
    } else if (trimmedText.toLowerCase() === 'false') {
      return false;
    } else {
      return Number(trimmedText);
    }
  } else {
    return trimmedText.substring(1, trimmedText.length - 1);
  }
}

export const extractDataTypeFromText = (text: string): string | number | boolean | (string | number | boolean)[] => {
  const trimmedText = text.trim();
  if (trimmedText.startsWith('[') && trimmedText.endsWith(']')) {
    return trimmedText.substring(1, trimmedText.length - 1).split(',').map(t => extractSingleDataTypeFromText(t));
  } else {
    return extractSingleDataTypeFromText(text);
  }
}

export const extractCreditRuleArray = (text: string) => {
  const trimmedText = text.trim();
  let array = [trimmedText];
  const operators = ["+", "-", "*", "/", "!=", "==", ">=", "<=", ">", "<", "DOT", "NOT IN", "IN", "AND", "OR"];
  for (const operator of operators) {
    let newArray = [...array];
    let newArrayIndex = 0;
    for (let i = 0; i < array.length; i++) {
      if (!operators.includes(array[i]) && array[i].includes(operator)) {
        const splits = array[i].split(operator);
        const splitsArray = [];
        for (let j = 0; j < splits.length; j++) {
          splitsArray.push(splits[j]);
          if (j != splits.length - 1) {
            splitsArray.push(operator);
          }
        }
        newArray = [...newArray.slice(0, newArrayIndex), ...splitsArray, ...array.slice(i + 1, array.length)];
        newArrayIndex += splitsArray.length - 1;
      }
      newArrayIndex++;
    }
    array = [...newArray];
  }

  array = array.filter(a => a !== '');
  console.log(array)
  return array;
}

// {Individual.PropertyOwnerFlag} == true AND {Entity.ABN} NOT IN [1, 2, 3] AND {Entity.EntityType} IN [2, 3, 4]
export const validateCreditRule = (creditRuleObjects: string[]): boolean => {
  let array = processCreditRule(creditRuleObjects);

  console.log(array);
  array = array.filter(a => a.value !== "(" && a.value !== ")");
  if (array.length) {
    if (array.length > 1) {
      if (array.length % 2 == 0) {
        return false;
      } else {
        let valid = true;
        for (let i = 0; i < array.length; i++) {
          if (i % 2 == 0) {
            valid = valid && array[i].type !== 'operator' && !Number.isNaN(array[i].value);
          } else {
            valid = valid && array[i].type === 'operator';
          }
        }
        return valid;
      }
    } else {
      // single entry - cannot be an operator
      return array[0].type !== 'operator';
    }
  } else {
    // should have at least one entry
    return false;
  }
}

export const processCreditRule = (creditRuleObjects: string[]): CreditRuleObject[] => {
  const operators = ["(", ")", "+", "-", "*", "/", "!=", "==", ">=", "<=", ">", "<", "DOT", "NOT IN", "IN", "AND", "OR"];
  const result: CreditRuleObject[] = [];
  for (let item of creditRuleObjects) {
    console.log('==item ', item)
    if (operators.includes(item)) {
      result.push({
        type: 'operator',
        value: item.trim(),
      })
    } else if (String(item).trim().startsWith("{") && String(item).trim().endsWith("}")) {
      const trimmedItem = String(item).trim();
      result.push({
        type: 'variable',
        value: trimmedItem.slice(1, trimmedItem.length - 1),
      })
    } else {
      result.push({
        type: 'value',
        value: extractDataTypeFromText(typeof item === "object" ? JSON.stringify(item) : String(item))
      })
    }
  }

  return result;
}


export const creditRuleItemValue = (value: string, outputType: CreditRuleItemOutputType) => {
  const trimmedValue = value.trim();
  if (outputType === 'Date' || outputType === 'Date Time') {
    return new Date(trimmedValue)
  } else if (outputType === 'Array') {
    return parseJSON(trimmedValue);
  } else if (outputType === 'Float' || outputType === 'Int') {
    return Number(trimmedValue);
  } else if (outputType === 'Boolean') {
    if (trimmedValue.toLowerCase() === 'true') {
      return true;
    } else if (trimmedValue.toLowerCase() === 'false') {
      return false;
    } else {
      return trimmedValue;
    }
  }
  return trimmedValue;
}

export const creditRuleItemFunction = (value: any, creditRuleItem: CreditRuleItem) => {
  const itemFunction = creditRuleItem.itemFunction;
  const Moment = moment;
  switch (itemFunction) {
    case 'Number':
      return Number(value);
    case 'Count':
      return value.length;
    case 'First':
      return value.length ? value[0] : value;
    case 'Last':
      return value.length ? value[value.length - 1] : value;
    case 'Uppercase':
      return String(value).toUpperCase();
    case 'Lowercase':
      return String(value).toLowerCase();
    case 'Round':
      return _.round(value, 2);
    case 'Round up':
      return _.ceil(value);
    case 'Round down':
      return _.floor(value);
    case 'Sum':
      return value.reduce((partialSum: number, a: number) => partialSum + a, 0);
    case 'Maximum':
      return Math.max(...value);
    case 'Minimum':
      return Math.min(...value);
    case 'Average':
      return value.length ? _.round(value.reduce((partialSum: number, a: number) => partialSum + a, 0) / value.length, 2) : 0;
    case 'Age':
      return moment().diff(value, 'years', true);
    case 'DB Value':
      return value.length ? Object.values(value[0])[0] : value;
    case 'Contains Deregistered':
      return JSON.stringify(value).includes('Deregistered');
    case 'Max Age':
      return Math.max(...value.map((r: any) => moment().diff(r, 'years', true)));
    case 'Min Age':
      return Math.min(...value.map((r: any) => moment().diff(r, 'years', true)));
    case 'Stringify':
      return JSON.stringify(value);
    default:
      return value;
  }
}

export const evaluateOperator = (
  first: any, second: any,
  operator: CreditRuleOperator
) => {
  switch (operator) {
    case '+':
      return first + second;
    case '-':
      return first - second;
    case '*':
      return first * second;
    case '/':
      return first / second;
    case '!=':
      return first != second;
    case '==':
      return first == second;
    case '>=':
      return first >= second;
    case '<=':
      return first <= second;
    case '>':
      return first > second;
    case '<':
      return first < second;
    case 'NOT IN':
      return !second.includes(first);
    case 'IN':
      return second.includes(first);
    case 'AND':
      return first && second;
    case 'OR':
      return first || second;
    case 'DOT':
      return first[second];
    default:
      return first;
  }
}

// Returns true if 'op2' has
// higher or same precedence as 'op1',
// otherwise returns false.
export const hasPrecedence = (op1: CreditRuleOperator, op2: CreditRuleOperator): boolean => {
  if (op2 == '(' || op2 == ')') {
    return false;
  }
  if ((op1 == '*' || op1 == '/' || op1 == 'AND' || op1 == 'OR' || op1 == 'IN' || op1 == 'NOT IN') &&
    (op2 == '+' || op2 == '-')) {
    return false;
  }
  else {
    return true;
  }
}

// ==============================
// ==== Bank Statements
// ==============================
export const bankTransactionCatogory = (category: string) => {
  // || categories.includes('')
  const categories = category ? category.split(',').map(c => _.toLower(c.trim().replace(/\s/g, '-'))) : [];
  if (categories.includes('wages') || categories.includes('wages-paid-out') || categories.includes('eftpos-terminals')) {
    return 'type-1';
  } else if (categories.includes('loans') || categories.includes('non-sacc-loans')) {
    return 'type-2';
  } else if (categories.includes('other-debits') || categories.includes('uncategorised-debits') || categories.includes('third-party-payment-providers')) {
    return 'type-3';
  } else if (categories.includes('tax') || categories.includes('atm') || categories.includes('refunds-and-returns') || categories.includes('other-income') || categories.includes('government-and-council-services') || categories.includes('subscription-tv') || categories.includes('travel')) {
    return 'type-4';
  } else if (categories.includes('online-retail-and-subscription-services')) {
    return 'type-5';
  } else if (categories.includes('external-transfers')) {
    return 'type-6';
  } else if (categories.includes('superannuation')) {
    return 'type-7';
  } else if (categories.includes('fees')) {
    return 'type-8';
  } else if (categories.includes('utilities')) {
    return 'type-9';
  } else if (categories.includes('groceries')) {
    return 'type-10';
  } else if (categories.includes('dining-out') || categories.includes('education') || categories.includes('automotive') || categories.includes('health') || categories.includes('department-stores') || categories.includes('retail') || categories.includes('home-improvement') || categories.includes('entertainment') || categories.includes('internal-transfer') || categories.includes('pet-care')) {
    return 'type-11';
  } else if (categories.includes('insurance')) {
    return 'type-12';
  } else if (categories.includes('telecommunications')) {
    return 'type-13';
  } else if (categories.includes('transport')) {
    return 'type-14';
  } else if (categories.includes('all-other-credits')) {
    return 'type-15';
  } else {
    return ''
  }
}

export const encodeReferenceForBankstatement = (reference: string, type: 'Individual' | 'Business', action: 'manage' | 'connect' = 'connect') => {
  const data = {
    reference,
    type,
    action : action ?? 'connect'
  }
  return btoa(JSON.stringify(data))
}

export const decodeReferenceForBankstatement = (encodedReference: string): { reference: string, type: 'Individual' | 'Business', action: 'manage' | 'connect' } => {
  const data = JSON.parse(atob(encodedReference))
  return data;
}

export const getProductTypeSf = (application: Application) => {
  const applicationType = application.ApplicationType;
  console.log('==applicationType ', applicationType);
  const productType = (application.AppInfo as any).productType;
  if (applicationType === 'AssetFinance') {
    switch (productType) {
      case 'FULL DOC':
        return 'FULL DOC';
      case 'EASY DOC':
        return 'EASY DOC';
      case 'FAST DOC':
        return 'FAST DOC';
      default:
        return 'FAST DOC';
    }
  } else if (applicationType === 'BusinessLoans') {
    return 'BUSINESS LOAN';
  } else if (applicationType === 'InsurancePremium') {
    return 'INSURANCE PREMIUM FUNDING';
  } else if (applicationType === 'Consumer') {
    return 'Consumer';
  } else if (applicationType === 'CorporateLoans') {
    return 'BUSINESS LOAN';
  } else if (applicationType === 'BusinessOverdraft') {
    return 'BUSINESS LOAN';
  } else {
    return 'FAST DOC'
  }
}


export const mapToNormalizedTransaction = (transaction: PismoGenericTransaction, hasDetails?: boolean): PismoNormalizedTransaction => {
  // Handle PismoTransaction
  if ((transaction as PismoTransaction).id) {
    const tx = transaction as PismoTransaction;
    const normalizedTransaction: PismoNormalizedTransaction = {
      id: tx.id,
      account_id: tx.account_id,
      customer_id: tx.customer_id,
      processing_code: tx.processing_code,
      soft_descriptor: tx.soft_descriptor,
      created_at: tx.created_at,
      event_date: tx.event_date,
      amount: tx.amount[0]?.value ?? 0,
      transaction_category: getTransactionCategory(tx),
      transaction_type: tx.transaction_type.id.toString() as PismoTransactionTypeIds,
      is_credit: tx.transaction_type.credit,
      currency: tx.amount[0]?.currency,
      card: tx.card ? {
        id: tx.card.id,
        name: tx.card.name,
        last_4_digits: tx.card.last_4_digits,
        printed_name: tx.card.printed_name
      } : undefined,
      tracking_id: tx.authorization.tracking_id,
      merchant: tx.merchant ? {
        name: tx.merchant.name,
        category: tx.merchant.category,
        city: tx.merchant.city,
        state: tx.merchant.state
      } : undefined,
      metadata: tx.metadata,
      isPending: false,
      hasDetails: hasDetails ?? false,
      type: 'transaction'
    };
    return normalizedTransaction;
  }

  // Handle PismoPendingTransaction
  if ((transaction as PismoPendingTransaction).data?.item) {
    const pendingTx = transaction as PismoPendingTransaction;
    const normalizedTransaction: PismoNormalizedTransaction = {
      id: pendingTx.data.item.id ?? pendingTx.correlation_id,
      account_id: pendingTx.account_id,
      customer_id: pendingTx.data.item.customer_id,
      processing_code: pendingTx.data.item.org_operation.processing_code,
      soft_descriptor: pendingTx.data.item.soft_descriptor,
      created_at: pendingTx.timestamp,
      amount: pendingTx.data.item.contract_amount,
      currency: pendingTx.data.item.currency_code,
      card: pendingTx.data.item.card_id ? {
        id: pendingTx.data.item.card_id,
        name: pendingTx.data.item.card_name,
      } : undefined,
      tracking_id: pendingTx.correlation_id,
      token_information: pendingTx.data.item.token_information,
      correlation_id: pendingTx.correlation_id,
      event_date: pendingTx.tenant_account_timestamp,
      is_credit: pendingTx.data.item.org_operation.processing_code === PismoTransactionProcessingCode.PAYMENT,
      transaction_category: getTransactionCategory(pendingTx),
      transaction_type: getPismoTransactionType(pendingTx),
      merchant: pendingTx.data.item.merchant_category_code ? {
        name: pendingTx.data.item.soft_descriptor,
        category: {
          code: pendingTx.data.item.merchant_category_code,
          description: pendingTx.data.item.merchant_category_group,
          group_name: pendingTx.data.item.merchant_category_group,
        },
        city: pendingTx.data.item.merchant_city,
        state: pendingTx.data.item.merchant_state_or_country
      } : undefined,
      metadata: pendingTx.metadata,
      isPending: true,
      hasDetails: hasDetails ?? false,
      type: 'pending'
    };
    return normalizedTransaction;
  }

  // Handle PismoServiceBusNetworkTransaction
  if ((transaction as PismoServiceBusNetworkTransaction).merchant?.category) {
    const networkTx = transaction as PismoServiceBusNetworkTransaction;
    const normalizedTransaction: PismoNormalizedTransaction = {
      id: networkTx.authorization.id,
      account_id: networkTx.account_id,
      customer_id: networkTx.customer_id,
      processing_code: networkTx.processing_code as PismoTransactionProcessingCode,
      soft_descriptor: networkTx.soft_descriptor,
      created_at: networkTx.created_at,
      event_date: networkTx.event_date,
      amount: networkTx.amount[0]?.value ?? 0,
      transaction_category: getTransactionCategory(networkTx),
      transaction_type: getPismoTransactionType(networkTx),
      is_credit: networkTx.processing_code === PismoTransactionProcessingCode.PAYMENT,
      currency: networkTx.currency,
      card: networkTx.card ? {
        id: networkTx.card.id,
        last_4_digits: networkTx.card.last_4_digits,
        printed_name: networkTx.card.printed_name
      } : undefined,
      merchant: networkTx.merchant ? {
        name: networkTx.merchant.name,
        category: {
          code: networkTx.merchant.category.code,
        }
      } : undefined,
      isPending: false,
      hasDetails: hasDetails ?? false,
      authorization_category: networkTx.authorization_category,
      type: 'network'
    };
    return normalizedTransaction;
  }

  // Handle PismoServiceBusPaymentTransaction
  const paymentTx = transaction as PismoServiceBusPaymentTransaction;
  return {
    id: paymentTx.authorization.id,
    account_id: paymentTx.account_id,
    customer_id: 0,
    processing_code: paymentTx.processing_code as PismoTransactionProcessingCode,
    soft_descriptor: paymentTx.descriptor,
    created_at: paymentTx.created_at,
    event_date: paymentTx.created_at,
    amount: paymentTx.amount[0]?.value ?? 0,
    transaction_category: getTransactionCategory(paymentTx),
    transaction_type: getPismoTransactionType(paymentTx),
    is_credit: paymentTx.processing_code === PismoTransactionProcessingCode.PAYMENT,
    tracking_id: paymentTx.tracking_id,
    metadata: paymentTx.metadata,
    isPending: false,
    hasDetails: hasDetails ?? false,
    type: 'payment'
  };
};

export type AccessLevelType = 'credit' | 'salesBDM' | 'operations' | 'salesAM' | 'admin' | string;

export const filterActiveUsers = (user: { sfId?: string | null; sfContactId?: string | null; isDisabled?: boolean }, isSfId: boolean = true): boolean => {
  const id = isSfId ? user.sfId : user.sfContactId;
  return !user.isDisabled && id !== null && id?.trim() !== '';
}
export const mapUserToSearchableSelectItem = (user: User, includeEmail: boolean = true): SearchableSelectItem => {
  const name = `${user.GivenName} ${user.FamilyName}`.trim();
  const value = user.UserId.toString();
  const id = user.sfId?.toString() || '';
  const mobileNumber = user.MobileNumber || '';
  const email = user.Email || '';
  return {
    value,
    label: `${name} ${includeEmail ? email : ''}`,
    name,
    email,
    id,
    searchTerm: name.toLowerCase(),
    mobileNumber
  };
};

export const setDefaultUserValues = (
  defaultUser: SearchableSelectItem | undefined,
  control: FormControl<string[] | null>,
  selectedUser: UserSelectionValue | null,
  defaultUserName: string | null
): { selectedUser: UserSelectionValue | null; defaultUserName: string | null } => {

  if (defaultUser) {
    const { label, value, name, email, id, mobileNumber } = defaultUser;
    control.setValue([value]);
    return {
      selectedUser: {
        UserId: parseInt(value, 10),
        Name: label || '',
        Email: email || '',
        sfContactId: id || '',
        MobileNumber: mobileNumber || ''
      },
      defaultUserName: label
    };
  }
  return { selectedUser, defaultUserName };
};

export type SystemUserType = 'sales' | 'settlement';

export const setDefaultSystemUserValues = (
  control: FormControl<string[] | null>,
  selectedUser: UserSelectionValue | null,
  defaultUserName: string | null,
  systemUserType: SystemUserType = 'sales'
): { selectedUser: UserSelectionValue | null; defaultUserName: string | null } => {
  let newSelectedUser: UserSelectionValue;

  if (systemUserType === 'sales') {
    newSelectedUser = {
      UserId: 971,
      Name: 'System Default',
      Email: '',
      sfContactId: '0057F000007aoYdQAI',
      MobileNumber: ''
    };
  } else {
    newSelectedUser = {
      UserId: 0,
      Name: '',
      Email: '',
      sfContactId: '',
      MobileNumber: '',
      sfId: ''
    };
  }

  selectedUser = newSelectedUser;
  control.setValue([selectedUser.UserId.toString()]);
  defaultUserName = selectedUser.Name;

  return { selectedUser, defaultUserName };
};

export const findDefaultUser = (
  users: SearchableSelectItem[],
  id: number | string | null | undefined | { toString: () => string }
): SearchableSelectItem | undefined => {
  if (!id) return undefined;
  const idString = typeof id === 'object' ? id.toString() : String(id);
  return users.find(user => user.value === idString);
};

export type UserSelectionType =
  | 'submitter'
  | 'broker'
  | 'sales-contact'
  | 'credit-officer'
  | 'settlement'
  | 'additional-correspondent'
  | 'aml-officer';

export const emitUserSelectionEvent = (
  event: UserSelectionComponentEvent,
  type: UserSelectionType,
  emitter: EventEmitter<UserSelectionComponentEvent & { type: UserSelectionType }>
): void => {
  emitter.emit({
    ...event,
    type,
  });
};

export const createUserSelectionEvent = (selectedItem: SearchableSelectItem): UserSelectionComponentEvent => {
  return {
    value: {
      UserId: parseInt(selectedItem.value),
      Name: selectedItem.label ?? '',
      Email: selectedItem.email ?? '',
      sfContactId: selectedItem.id,
      MobileNumber: selectedItem.mobileNumber ?? '',
    },
  };
}

/** searchable-select cannot be cleared, so unassigning is an item of its own. Parses to NaN as a UserId. */
export const AML_OFFICER_UNASSIGNED_VALUE = 'unassigned';

export const canSetAmlOfficer = (u?: Pick<User, 'AccessLevel'> | null): boolean =>
  isAdmin(u) || isOperations(u) || isOperations24(u);

/**
 * "Unassigned", then the candidates. The current officer is kept even after losing the operations
 * access level, otherwise the select would show nothing for them.
 */
export const amlOfficerSearchableSelectItems = (
  application: Pick<Application, 'amlOfficerUserId' | 'amlOfficerFirstName' | 'amlOfficerLastName' | 'amlOfficerEmail'>,
  candidates: AmlOfficerCandidate[],
): SearchableSelectItem[] => {
  const toItem = (userId: number, givenName: string | null, familyName: string | null, email: string | null): SearchableSelectItem => {
    const name = [givenName, familyName].filter(Boolean).join(' ') || email || `User ${userId}`;
    return {
      id: '',
      value: userId.toString(),
      label: `${name} ${email ?? ''}`.trim(),
      name,
      email,
      searchTerm: name.toLowerCase(),
    };
  };
  const items: SearchableSelectItem[] = [
    { id: '', value: AML_OFFICER_UNASSIGNED_VALUE, label: 'Unassigned', name: 'Unassigned', searchTerm: 'unassigned' },
  ];
  const currentId = application.amlOfficerUserId;
  if (currentId && !candidates.some(candidate => candidate.UserId === currentId)) {
    items.push(toItem(currentId, application.amlOfficerFirstName, application.amlOfficerLastName, application.amlOfficerEmail));
  }
  return [
    ...items,
    ...candidates.map(candidate => toItem(candidate.UserId, candidate.GivenName, candidate.FamilyName, candidate.Email)),
  ];
};

export const amlOfficerSelectValue = (application: Pick<Application, 'amlOfficerUserId'>): string =>
  application.amlOfficerUserId ? application.amlOfficerUserId.toString() : AML_OFFICER_UNASSIGNED_VALUE;

export const mapBrokerCompanyToSearchableSelectItem = (company: {
  EntityName?: string | null;
  Email?: string | null;
  OriginatorBusinessId?: number | string;
  SalesforceId?: string | null;
}): SearchableSelectItem => {
  const name = company.EntityName || 'Unknown';
  const email = company.Email || '';
  const id = company.SalesforceId || ''
  const value = company.SalesforceId?.toString() || ''
  return {
    value: value,
    label: name,
    id: id,
    searchTerm: name.toLowerCase(),
    email: email,
  };
};

export const mapBrokerUserToSearchableSelectItem = (user: {
  UserId: number;
  Name?: string;
  Email?: string;
  sfContactId?: string;
  MobileNumber?: string;
}): SearchableSelectItem => {
  const name = user.Name || '';
  const email = user.Email || '';
  const mobileNumber = user.MobileNumber || '';
  const id = user.sfContactId || ''
  const value = user.UserId.toString() || ''
  return {
    value: value,
    label: `${name} ${email}`.trim(),
    id: id,
    searchTerm: name.toLowerCase(),
    email,
    mobileNumber
  };
};

export const toCapitalCaseFirstChar = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toLabelCase = (key: string): string => {
  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2') // split camelCase
    .replace(/_/g, ' ')                  // replace underscores
    .replace(/\bid\b/gi, 'ID')           // optional: capitalize 'id'
    .replace(/\b(\w)/g, char => char.toUpperCase()); // capitalize first letter of each word
}
// Generic function to normalize any JSON object or array of objects with recursive nested support
export const normalizeJson = <T = any>(data: T | T[]): {
  normalizedData: any,
  propertyMap: Record<number, string>
} => {
  const allPropertyPaths = new Set<string>();

  // Recursively collect all property paths to handle name conflicts
  const collectPropertyPaths = (obj: any, path: string = '') => {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          collectPropertyPaths(item, path);
        }
      });
    } else if (typeof obj === 'object' && obj !== null) {
      Object.keys(obj).forEach(key => {
        const currentPath = path ? `${path}.${key}` : key;
        allPropertyPaths.add(currentPath);

        const value = obj[key];
        if (typeof value === 'object' && value !== null) {
          collectPropertyPaths(value, currentPath);
        }
      });
    }
  };

  // Collect all property paths
  collectPropertyPaths(data);

  // Create property map with full paths
  const propertyMap: Record<number, string> = {};
  const reverseMap: Record<string, number> = {};

  Array.from(allPropertyPaths).sort().forEach((propPath, index) => {
    propertyMap[index] = propPath;
    reverseMap[propPath] = index;
  });

  // Recursively normalize the data
  const normalizeRecursive = (obj: any, path: string = ''): any => {
    if (Array.isArray(obj)) {
      return obj.map(item => normalizeRecursive(item, path));
    } else if (typeof obj === 'object' && obj !== null) {
      const normalized: Record<number, any> = {};

      Object.entries(obj).forEach(([key, value]) => {
        const currentPath = path ? `${path}.${key}` : key;
        const normalizedKey = reverseMap[currentPath];

        if (normalizedKey !== undefined) {
          // Recursively normalize nested objects/arrays
          normalized[normalizedKey] = normalizeRecursive(value, currentPath);
        }
      });

      return normalized;
    }

    // Return primitive values as-is
    return obj;
  };

  const normalizedData = normalizeRecursive(data);

  return { normalizedData, propertyMap };
};

// Generic function to denormalize JSON data back to original property names with recursive nested support
export const denormalizeJson = <T = any>(
  normalizedData: any,
  propertyMap: Record<number, string>
): T => {
  // Helper function to set nested property using dot notation path
  const setNestedProperty = (obj: any, path: string, value: any) => {
    const keys = path.split('.');
    let current = obj;

    // Navigate to the parent object
    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      if (!(key in current) || typeof current[key] !== 'object' || current[key] === null) {
        current[key] = {};
      }
      current = current[key];
    }

    // Set the final value
    current[keys[keys.length - 1]] = value;
  };

  // Recursively denormalize the data
  const denormalizeRecursive = (obj: any, parentPath: string = ''): any => {
    if (Array.isArray(obj)) {
      return obj.map(item => denormalizeRecursive(item, parentPath));
    } else if (typeof obj === 'object' && obj !== null) {
      // Check if this is a normalized object (has numeric keys)
      const hasNumericKeys = Object.keys(obj).some(key => !isNaN(parseInt(key)));

      if (hasNumericKeys) {
        // This is a normalized object, denormalize it
        const denormalized: Record<string, any> = {};

        Object.entries(obj).forEach(([numKey, value]) => {
          const numericKey = parseInt(numKey);
          if (!isNaN(numericKey) && Object.prototype.hasOwnProperty.call(propertyMap, numericKey)) {
            let originalPropertyPath = propertyMap[numericKey];
            if (parentPath) {
              originalPropertyPath = originalPropertyPath.split(parentPath + '.')[1];
            }
            const denormalizedValue = denormalizeRecursive(value, parentPath ? parentPath + '.' + originalPropertyPath : originalPropertyPath);
            setNestedProperty(denormalized, originalPropertyPath, denormalizedValue);
          }
        });

        return denormalized;
      } else {
        // This is not a normalized object, recursively process its values
        const result: Record<string, any> = {};
        Object.entries(obj).forEach(([key, value]) => {
          result[key] = denormalizeRecursive(value, parentPath ? parentPath + '.' + key : key);
        });
        return result;
      }
    }

    // Return primitive values as-is
    return obj;
  };

  return denormalizeRecursive(normalizedData, '') as T;
};

export const formatAmount = (value: number | string | undefined, decimalPlace = 2) => {
  if (typeof value == 'undefined' || value === 0 || value === '0') {
    return `$0.00`
  }

  if (typeof value == 'string') {
    value = parseFloat(value);
  }
  const isPositive = value && value > 0;
  const number = value ? Math.abs(value) : 0;
  const formattedValue = number.toFixed(decimalPlace).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${isPositive ? '' : '-'}$${formattedValue}`
}

export const parseDate = (d: string): Date => {
  const [day, month, year] = d.split("-");
  return new Date(`${year}-${month}-${day}`);
}



// bureau dates are DD-MM-YYYY strings; convert to YYYY-MM-DD for DATE columns
const creditorwatchDateToIso = (d: string | null | undefined): string | null => {
  if (!d || typeof d !== 'string') return null;
  const parts = d.split('-');
  if (parts.length !== 3) return null;
  const [dd, mm, yyyy] = parts;
  return `${yyyy}-${mm}-${dd}`;
};

const creditorwatchCourtJudgementToAdverseItem = (
  obj: any,
  source: CreditorwatchAdverseItemSource,
  relatedEntityName: string | null,
  relatedEntityNumber: string | null,
): CreditorwatchAdverseItem => ({
  itemType: 'CourtAction',
  source,
  relatedEntityName,
  relatedEntityNumber,
  itemDate: creditorwatchDateToIso(obj?.['actionDate']),
  amount: obj?.['judgementAmount'] ?? null,
  counterpartyName: obj?.['plaintiff'] ?? null,
  settled: null,
});

const creditorwatchPaymentDefaultToAdverseItem = (
  obj: any,
  source: CreditorwatchAdverseItemSource,
  relatedEntityName: string | null,
  relatedEntityNumber: string | null,
): CreditorwatchAdverseItem => ({
  itemType: 'PaymentDefault',
  source,
  relatedEntityName,
  relatedEntityNumber,
  itemDate: creditorwatchDateToIso(obj?.['paymentDueDate']),
  amount: obj?.['amountOutstanding'] ?? null,
  counterpartyName: obj?.['posterName'] ?? null,
  settled: !!obj?.['defaultSettled'],
});

export const extractCreditorwatchData = (data: CreditorWatchReportData): CreditorwatchExtraction => {
  let extraction: CreditorwatchExtraction = {
    error: '',
    adverseItems: [],
    noOfUnpaidDefaults: null,
    mostRecentUnpaidDefault: null,
    totalUnpaidDefault: null,
    noOfPaidDefaults: null,
    mostRecentPaidDefault: null,
    totalPaidDefault: null,
    noOfJudgements: null,
    mostRecentJudgement: null,
    creditorwatchScore: null,
    deregisteredEntity: null,
    atoDefaults: null,
    insolvencyNoticesFromCertainParty: null,
    unpaidDefault: null,
    mercantileEnquiries: null,
    courtActions: null,
    directorAppointmentDateLessThan12Months: null,
    rating: null,
    crossDirectorshipCourtActionsOrDefaults: null,
    paidDefaults: null,
    currentDirectorshipHighRisk: null,
    directorAppointmentDateLessThan24Months: null,
  };

  // noOfUnpaidDefaults
  try {
    extraction.noOfUnpaidDefaults = data?.['creditReport']?.['paymentDefaults'].filter(obj => !obj['defaultSettled']).length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting noOfUnpaidDefaults: ' + errorMessage + ' ';
  }

  // mostRecentUnpaidDefault
  try {
    const date = !extraction.noOfUnpaidDefaults ? null : data?.['creditReport']?.['paymentDefaults'].filter(obj => !obj['defaultSettled']).reduce((latest, current) => {
      if (!current?.paymentDueDate) return latest; // skip null/empty
      const currDate = parseDate(current?.paymentDueDate);
      if (!latest) return current;
      const latestDate = parseDate(latest?.paymentDueDate);
      return currDate > latestDate ? current : latest;
    }, null)?.paymentDueDate;
    if (date && date.length) {
      const [dd, mm, yyyy] = date.split("-");
      extraction.mostRecentUnpaidDefault = `${yyyy}-${mm}-${dd}` as any;
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting mostRecentUnpaidDefault: ' + errorMessage + ' ';
  }

  // totalUnpaidDefault
  try {
    extraction.totalUnpaidDefault = data?.['creditReport']?.['paymentDefaults'].filter(obj => !obj['defaultSettled']).reduce((a, b) => _.round(a + b['amountOutstanding'], 2), 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting totalUnpaidDefault: ' + errorMessage + ' ';
  }

  // noOfPaidDefaults
  try {
    extraction.noOfPaidDefaults = data?.['creditReport']?.['paymentDefaults'].filter(obj => obj['defaultSettled']).length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting noOfPaidDefaults: ' + errorMessage + ' ';
  }

  // mostRecentPaidDefault
  try {
    const date = !extraction.noOfPaidDefaults ? null : data?.['creditReport']?.['paymentDefaults'].filter(obj => obj['defaultSettled']).reduce((latest, current) => {
      if (!current?.paymentDueDate) return latest; // skip null/empty
      const currDate = parseDate(current?.paymentDueDate);
      if (!latest) return current;
      const latestDate = parseDate(latest?.paymentDueDate);
      return currDate > latestDate ? current : latest;
    }, null)?.paymentDueDate;
    if (date && date.length) {
      const [dd, mm, yyyy] = date.split("-");
      extraction.mostRecentPaidDefault = `${yyyy}-${mm}-${dd}` as any;
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting mostRecentPaidDefault: ' + errorMessage + ' ';
  }

  // totalPaidDefault
  try {
    extraction.totalPaidDefault = data?.['creditReport']?.['paymentDefaults'].filter(obj => obj['defaultSettled']).reduce((a, b) => _.round(a + b['amountOutstanding'], 2), 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting totalPaidDefault: ' + errorMessage + ' ';
  }

  // noOfJudgements
  try {
    extraction.noOfJudgements = data?.['creditReport']?.['courtJudgements'].filter(obj => obj?.['plaintiff']).length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting noOfJudgements: ' + errorMessage + ' ';
  }

  // mostRecentJudgement
  try {
    const date = !extraction.noOfJudgements ? null : data?.['creditReport']?.['courtJudgements'].reduce((latest, current) => {
      if (!current?.actionDate) return latest; // skip null/empty
      const currDate = parseDate(current?.actionDate);
      if (!latest) return current;
      const latestDate = parseDate(latest?.actionDate);
      return currDate > latestDate ? current : latest;
    }, null)?.actionDate;
    if (date && date.length) {
      const [dd, mm, yyyy] = date.split("-");
      extraction.mostRecentJudgement = `${yyyy}-${mm}-${dd}` as any;
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting mostRecentJudgement: ' + errorMessage + ' ';
  }

  // CreditorwatchScore
  try{
    extraction.creditorwatchScore = data?.['creditScore']?.['currentCreditScore'];
     
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
   extraction.error += 'Error when extracting CreditorwatchScore: ' + errorMessage + ' ';
  }

  //deregisteredEntity
  try {
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting deregisteredEntity: ' + errorMessage + ' ';
  }

  //atoDefaults
  try {
    extraction.atoDefaults = data?.['creditReport']?.['atoTaxDefault']?.['debtAmount'] ?? 0;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting atoDefaults: ' + errorMessage + ' ';
  }


  //insolvencyNoticesFromCertainParty
  try {
    extraction.insolvencyNoticesFromCertainParty = data?.['organisationExtract']?.['companyOfficeHolders'].map(obj => obj['knownInformation']).flat(1).map(obj => obj?.['creditReport']?.['insolvencyNotices']).flat(1).filter(obj => obj?.['title'] && !['NOTICE OF PROPOSED DEREGISTRATION - ASIC initiated under s601AB(1) or (1A)', 'NOTICE OF PROPOSED DEREGISTRATION - Voluntary'].includes(obj['title']) && !(obj?.['ruling'] || '').toLowerCase().includes('corporations act 2001 subsection 601ab(3)')).length > 0
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting insolvencyNoticesFromCertainParty: ' + errorMessage + ' ';
  }

  //unpaidDefault
  try {
    extraction.unpaidDefault = data?.['creditReport']?.['paymentDefaults'].filter(obj => !obj['defaultSettled']).reduce((a, b) => a + b['amountOutstanding'], 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting unpaidDefault: ' + errorMessage + ' ';
  } 

  //mercantileEnquiries
  try {
    extraction.mercantileEnquiries = data?.['creditReport']?.['mercantileEnquiries'].filter(obj => JSON.stringify(obj).includes('agent')).length
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting mercantileEnquiries: ' + errorMessage + ' ';
  }

  //courtActions
  try {
    extraction.courtActions = data?.['creditReport']?.['courtJudgements'].filter(obj => obj?.['plaintiff']).length
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting courtActions: ' + errorMessage + ' ';
  }

  //directorAppointmentDateLessThan12Months
  try {
    extraction.directorAppointmentDateLessThan12Months = data?.['currentDirectors'] && data['currentDirectors'].length > 0 ? data?.['currentDirectors'].map(obj => obj['appointmentDate']).reduce((a, b) => a && (moment().diff(moment(b, 'DD-MM-YYYY'), 'years', true) < 1), true) : null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting directorAppointmentDateLessThan12Months: ' + errorMessage + ' ';
  }

  //rating
  try {
    extraction.rating = data?.['creditRating']?.['currentCreditRating'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting rating: ' + errorMessage + ' ';
  }
  
  //crossDirectorshipCourtActionsOrDefaults
  try {
    extraction.crossDirectorshipCourtActionsOrDefaults = data?.['organisationExtract']?.['companyOfficeHolders'].map(obj => obj['knownInformation']).flat(1).map(obj => obj['creditReport']).reduce((acc, cur) => acc || (!!cur['paymentDefaults'].length) || (!!cur['courtJudgements'].length), false)
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting crossDirectorshipCourtActionsOrDefaults: ' + errorMessage + ' ';
  }

  //paidDefaults
  try {
    extraction.paidDefaults = data?.['creditReport']?.['paymentDefaults'].filter(obj => obj['defaultSettled']).reduce((a, b) => a + b['amountOutstanding'], 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting paidDefaults: ' + errorMessage + ' ';
  }

  //currentDirectorshipHighRisk
  try {
    extraction.currentDirectorshipHighRisk = data?.['currentDirectors'].map(director => director['currentDirectorships']).flat(1).filter(obj => obj['isHighRisk']).length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting currentDirectorshipHighRisk: ' + errorMessage + ' ';
  }

  //directorAppointmentDateLessThan24Months
  try {
    extraction.directorAppointmentDateLessThan24Months = data?.['currentDirectors'] && data['currentDirectors'].length > 0 ? data?.['currentDirectors'].map(obj => obj['appointmentDate']).reduce((a, b) => a || (moment().diff(moment(b, 'DD-MM-YYYY'), 'years', true) < 2), false) : null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting directorAppointmentDateLessThan24Months: ' + errorMessage + ' ';
  }

  //adverseItems - subject entity court judgements and payment defaults, retained per item
  //(court judgements keep the same plaintiff-presence filter as noOfJudgements/courtActions above)
  try {
    const subjectJudgements = (data?.['creditReport']?.['courtJudgements'] ?? []).filter(obj => obj?.['plaintiff']);
    extraction.adverseItems.push(...subjectJudgements.map(obj => creditorwatchCourtJudgementToAdverseItem(obj, 'Subject', null, null)));
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting adverseItems (subject court judgements): ' + errorMessage + ' ';
  }
  try {
    const subjectDefaults = data?.['creditReport']?.['paymentDefaults'] ?? [];
    extraction.adverseItems.push(...subjectDefaults.map(obj => creditorwatchPaymentDefaultToAdverseItem(obj, 'Subject', null, null)));
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting adverseItems (subject payment defaults): ' + errorMessage + ' ';
  }

  //adverseItems - related entities via companyOfficeHolders[].knownInformation[].creditReport.
  //The same related entity can appear under multiple officeholders, so dedupe by organisation
  //number (falling back to name) to avoid double-counting in the count-based rules.
  try {
    const knownInformation = (data?.['organisationExtract']?.['companyOfficeHolders'] ?? [])
      .map(obj => obj?.['knownInformation'] ?? []).flat(1);
    const seenRelatedEntities = new Set<string>();
    for (const ki of knownInformation) {
      const relatedEntityName = ki?.['organisationName'] ?? null;
      const relatedEntityNumber = ki?.['organisationNumber'] ?? null;
      const dedupeKey = `${relatedEntityNumber ?? ''}|${relatedEntityName ?? ''}`;
      if (dedupeKey !== '|' && seenRelatedEntities.has(dedupeKey)) {
        continue;
      }
      seenRelatedEntities.add(dedupeKey);
      const relatedJudgements: any[] = (ki?.['creditReport']?.['courtJudgements'] ?? []).filter((obj: any) => obj?.['plaintiff']);
      extraction.adverseItems.push(...relatedJudgements.map(obj => creditorwatchCourtJudgementToAdverseItem(obj, 'RelatedEntity', relatedEntityName, relatedEntityNumber)));
      const relatedDefaults: any[] = ki?.['creditReport']?.['paymentDefaults'] ?? [];
      extraction.adverseItems.push(...relatedDefaults.map(obj => creditorwatchPaymentDefaultToAdverseItem(obj, 'RelatedEntity', relatedEntityName, relatedEntityNumber)));
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting adverseItems (related entities): ' + errorMessage + ' ';
  }

  return extraction;
}

export const extractEquifaxConsumerData = (data: EquifaxConsumerReportData): EquifaxConsumerExtraction => {
  let extraction: EquifaxConsumerExtraction = {
    error: '',
    bankruptcyFlag: null,
    financialHardshipFlag: null,
    directorScore: null,
    ageOfEquifaxFile: null,
    equifaxDirectorCourtActions: null,
    equifaxDirectorPaymentDefaults: null,
    equifaxDirectorMercantile: null,
    equifaxDirectorCourtWrits: null,
    equifaxDirectorPetitions: null,
    equifaxConsumerUnpaidDefaultsConsumer: null,
    equifaxConsumerUnpaidDefaultsCommercial: null,
    equifaxConsumerPaidDefaultsConsumer: null,
    equifaxConsumerPaidDefaultsCommercial: null,
    equifaxPersonalInsolvenciesCount: null,
    equifaxSummons: null,
    commercialEnquiries: null,
    commercialEnquiriesAfter6Months: null,
    consumerCreditEnquiries: null,
    rhiIndicatorOnCCR6Months: null,
    rhiIndicatorOnCCR12Months: null,
    equifaxConsumerPaidDefaultsConsumerSingleObject: null,
    equifaxConsumerPaidDefaultsCommercialSingleObject: null,
    ccrMortgageDataExists: null,
    directorRelatedEntityAdverse: null,
    bureauCheckResponseType: null,
    individualBureauAge: null,
    comprehensiveHighestRepaymentsStatus: null,
    comprehensiveHighestRecentRepaymentsStatus: null,
    noBureauReport: null,
    openAccounts: null,
  };

  // Equifax XML→JSON conversion emits a single object when there is exactly one
  // sibling element, and an array when there are multiple. The extraction logic
  // below uses array operators (.map/.find/.filter/.length) on these repeating
  // nodes, which throws or returns undefined when given a single object. Normalise
  // the known repeating nodes to arrays in-place so the existing logic works for
  // both shapes. The input has already been persisted as JSON before this function
  // is invoked (see credit.ts), so mutating the in-memory copy is safe.
  try {
    const toArray = <T>(value: T | T[] | undefined | null): T[] => {
      if (value == null) return [];
      return Array.isArray(value) ? value : [value];
    };
    const productData = (data as any)?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data'];
    const enquiryReport = productData?.['vs:enquiry-report'];
    const summaryData = productData?.['vs:summary-data'];
    const publicRecord = enquiryReport?.['vs:public-record-or-consumer-credit-information'];

    if (summaryData) {
      summaryData['vs:data-block'] = toArray(summaryData['vs:data-block']);
    }

    for (const fileKey of ['vs:consumer-credit-file', 'vs:commercial-credit-file'] as const) {
      const accountsContainer = enquiryReport?.[fileKey]?.['vs:accounts'];
      if (accountsContainer) {
        accountsContainer['vs:account'] = toArray(accountsContainer['vs:account']);
        for (const account of accountsContainer['vs:account']) {
          if (account?.['vs:repayment-history']) {
            account['vs:repayment-history']['vs:payment'] = toArray(account['vs:repayment-history']['vs:payment']);
          }
          if (account?.['vs:defaults']) {
            account['vs:defaults']['vs:default'] = toArray(account['vs:defaults']['vs:default']);
          }
        }
      }
    }

    if (publicRecord?.['vs:directorships']) {
      publicRecord['vs:directorships']['vs:directorship'] = toArray(publicRecord['vs:directorships']['vs:directorship']);
    }
    if (publicRecord?.['vs:personal-insolvencies']) {
      publicRecord['vs:personal-insolvencies']['vs:personal-insolvency'] = toArray(publicRecord['vs:personal-insolvencies']['vs:personal-insolvency']);
    }
    if (publicRecord?.['vs:court-actions']) {
      publicRecord['vs:court-actions']['vs:court-action'] = toArray(publicRecord['vs:court-actions']['vs:court-action']);
    }
    if (publicRecord?.['vs:court-writs']) {
      publicRecord['vs:court-writs']['vs:court-writ'] = toArray(publicRecord['vs:court-writs']['vs:court-writ']);
    }
    if (publicRecord?.['vs:petitions']) {
      publicRecord['vs:petitions']['vs:petition'] = toArray(publicRecord['vs:petitions']['vs:petition']);
    }
    if (publicRecord?.['vs:payment-defaults']) {
      publicRecord['vs:payment-defaults']['payment-default'] = toArray(publicRecord['vs:payment-defaults']['payment-default']);
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when normalising Equifax response shape: ' + errorMessage + ' ';
  }

  // bankruptcyFlag
  try {
    const dataBlock = data?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block'];
    if (Array.isArray(dataBlock)) {
      extraction.bankruptcyFlag = (dataBlock?.map(obj => obj?.['vs:characteristic']).flat(1).find(obj => obj?.['vs:variable-name'] === 'NP8512_inslv_bkrpt')?.['vs:value']?.['#text'] as number) > 0
    } else {
      extraction.bankruptcyFlag = ((dataBlock?.['vs:characteristic'] as any).flat(1).find((obj: any) => obj?.['vs:variable-name'] === 'NP8512_inslv_bkrpt')?.['vs:value']?.['#text'] as number) > 0
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting bankruptcyFlag: ' + errorMessage + ' ';
  }

  // financialHardshipFlag
  try {
    const dataBlock = data?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block'];
    if (Array.isArray(dataBlock)) {
      extraction.financialHardshipFlag = dataBlock?.map(obj => obj?.['vs:characteristic']).flat(1).find(obj => obj['@id'] === 'CX5000')?.['vs:value']?.['#text'] == 'Y';
    } else {
      extraction.financialHardshipFlag = (dataBlock?.['vs:characteristic'] as any).flat(1).find((obj: any) => obj?.['@id'] === 'CX5000')?.['vs:value']?.['#text'] == 'Y';
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting financialHardshipFlag: ' + errorMessage + ' ';
  }

  // directorScore
  try {
    extraction.directorScore = data?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:score-data']?.['vs:score']?.['vs:score-masterscale'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting directorScore: ' + errorMessage + ' ';
  }

  // ageOfEquifaxFile
  try {
    const dataBlock = data?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block'];
    if (Array.isArray(dataBlock)) {
      extraction.ageOfEquifaxFile = (dataBlock as any)?.map((obj: any) => obj?.['vs:characteristic']).flat(1).find((obj: any) => obj?.['vs:variable-name'] === 'NA8902_age_fle_max')?.['vs:value']?.['#text'];
    } else {
      extraction.ageOfEquifaxFile = (dataBlock?.['vs:characteristic'] as any).flat(1).find((obj: any) => obj?.['vs:variable-name'] === 'NA8902_age_fle_max')?.['vs:value']?.['#text'];
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting ageOfEquifaxFile: ' + errorMessage + ' ';
  }

  // equifaxDirectorCourtActions
  try {    
    extraction.equifaxDirectorCourtActions = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:public-record-or-consumer-credit-information']?.['vs:court-actions']?.['vs:court-action']?.length ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxDirectorCourtActions: ' + errorMessage + ' ';
  }
  
  // equifaxDirectorPaymentDefaults
  try {
    extraction.equifaxDirectorPaymentDefaults = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:public-record-or-consumer-credit-information']?.['vs:payment-defaults']?.['payment-default']?.length ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxDirectorPaymentDefaults: ' + errorMessage + ' ';
  }

  // equifaxDirectorMercantile
  try {
    extraction.equifaxDirectorMercantile = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:public-record-or-consumer-credit-information']?.['vs:mercantile']?.length ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxDirectorMercantile: ' + errorMessage + ' ';
  }

  // equifaxDirectorCourtWrits
  try {
    extraction.equifaxDirectorCourtWrits = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:public-record-or-consumer-credit-information']?.['vs:court-writs']?.['vs:court-writ']?.length ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxDirectorCourtWrits: ' + errorMessage + ' ';
  }

  // equifaxDirectorPetitions
  try {
    extraction.equifaxDirectorPetitions = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:public-record-or-consumer-credit-information']?.['vs:petitions']?.['vs:petition']?.length ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxDirectorPetitions: ' + errorMessage + ' ';
  }

  // equifaxConsumerUnpaidDefaultsConsumer
  try {
    extraction.equifaxConsumerUnpaidDefaultsConsumer = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:consumer-credit-file']['vs:accounts']['vs:account'].find((obj: any) => obj?.['vs:defaults']?.['vs:default']?.['vs:status']?.['#text']=='Outstanding')?.['vs:defaults']['vs:default']['vs:current-default']['vs:default-amount']['#text'] ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxConsumerUnpaidDefaultsConsumer: ' + errorMessage + ' ';
  }

  // equifaxConsumerUnpaidDefaultsCommercial
  try {
    extraction.equifaxConsumerUnpaidDefaultsCommercial = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:commercial-credit-file']['vs:accounts']['vs:account'].find((obj: any) => obj?.['vs:defaults']?.['vs:default']?.['vs:status']?.['#text']=='Outstanding')?.['vs:defaults']['vs:default']['vs:current-default']['vs:default-amount']['#text'] ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxConsumerUnpaidDefaultsCommercial: ' + errorMessage + ' ';
  }

  // equifaxConsumerPaidDefaultsConsumer
  try {
    extraction.equifaxConsumerPaidDefaultsConsumer = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:consumer-credit-file']['vs:accounts']['vs:account']
      .find((obj: any) => obj?.['vs:defaults']?.['vs:default']?.['vs:status']?.['#text']=='Paid')?.['vs:defaults']['vs:default']['vs:current-default']['vs:default-amount']['#text'] ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxConsumerPaidDefaultsConsumer: ' + errorMessage + ' ';
  }

  // equifaxConsumerPaidDefaultsCommercial
  try {
    extraction.equifaxConsumerPaidDefaultsCommercial = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:commercial-credit-file']['vs:accounts']['vs:account']
      .find((obj: any) => obj?.['vs:defaults']?.['vs:default']?.['vs:status']?.['#text']=='Paid')?.['vs:defaults']['vs:default']['vs:current-default']['vs:default-amount']['#text'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxConsumerPaidDefaultsCommercial: ' + errorMessage + ' ';
  }

  // equifaxPersonalInsolvenciesCount
  try {
    extraction.equifaxPersonalInsolvenciesCount = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:public-record-or-consumer-credit-information']['vs:personal-insolvencies']['vs:personal-insolvency']?.length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxPersonalInsolvenciesCount: ' + errorMessage + ' ';
  }

  // equifaxSummons
  try {
    extraction.equifaxSummons = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:public-record-or-consumer-credit-information']['vs:court-actions']['vs:court-action']?.length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxSummons: ' + errorMessage + ' ';
  }

  // commercialEnquiries
  try {
    extraction.commercialEnquiries = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:summary-data']['vs:data-block'].map((obj: any) => obj['vs:characteristic']).flat(1)
    .find((obj: any) => obj['vs:variable-name'] === 'NY8001_enq_3m')?.['vs:value']['#text'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting commercialEnquiries: ' + errorMessage + ' ';
  }

  // commercialEnquiriesAfter6Months
  try {
    extraction.commercialEnquiriesAfter6Months = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:summary-data']['vs:data-block'].map((obj: any) => obj['vs:characteristic']).flat(1)
      .find((data: any) => data['@id'] === 'NY8006')?.['vs:value']['#text'] - ((data as any)?.['soapenv:Envelope']['soapenv:Body']['vs:response']['vs:product-data']['vs:summary-data']['vs:data-block']
      .map((obj: any) => obj['vs:characteristic']).flat(1).find((data: any) => data['@id'] === 'NY8002')?.['vs:value']['#text'] ?? 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting commercialEnquiriesAfter6Months: ' + errorMessage + ' ';
  }

  // consumerCreditEnquiries
  try {
    extraction.consumerCreditEnquiries = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:summary-data']['vs:data-block'].map((obj: any) => obj['vs:characteristic']).flat(1).find((data: any) => data['@id'] === 'NX8006')?.['vs:value']['#text'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting consumerCreditEnquiries: ' + errorMessage + ' ';
  }

  // rhiIndicatorOnCCR6Months
  try {
    extraction.rhiIndicatorOnCCR6Months = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:consumer-credit-file']['vs:accounts']['vs:account'].map((obj: any) => obj['vs:repayment-history']?.['vs:payment']).flat(1)
      .filter(Boolean).slice(-6).map((payment: any) => payment['vs:status']).reduce((a: any, b: any) => typeof b === 'number' ? Math.max(a, b) : a, 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting rhiIndicatorOnCCR6Months: ' + errorMessage + ' ';
  }

  // rhiIndicatorOnCCR12Months
  try {
    extraction.rhiIndicatorOnCCR12Months = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:consumer-credit-file']['vs:accounts']['vs:account'].map((obj: any) => obj['vs:repayment-history']?.['vs:payment']).flat(1)
      .filter(Boolean).slice(-12).map((payment: any) => payment['vs:status']).map((a: any) => a === 'X' ? 99 : a).flat(1).reduce((a: any, b: any) => typeof b === 'number' ? Math.max(a, b) : a, 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting rhiIndicatorOnCCR12Months: ' + errorMessage + ' ';
  }

  // equifaxConsumerPaidDefaultsConsumerSingleObject
  // Original semantic: fire only when vs:account was a single object (now post-normalisation,
  // an array of length 1) and that single account has a Paid default. Multi-account responses
  // are intentionally returned as 0 to match prior behaviour.
  try {
    const accountList = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:consumer-credit-file']?.['vs:accounts']?.['vs:account'];
    if (Array.isArray(accountList) && accountList.length === 1) {
      const firstDefault = accountList[0]?.['vs:defaults']?.['vs:default']?.[0];
      extraction.equifaxConsumerPaidDefaultsConsumerSingleObject = firstDefault?.['vs:status']?.['#text'] == 'Paid'
        ? firstDefault?.['vs:current-default']?.['vs:default-amount']?.['#text']
        : 0;
    } else {
      extraction.equifaxConsumerPaidDefaultsConsumerSingleObject = 0;
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxConsumerPaidDefaultsConsumerSingleObject: ' + errorMessage + ' ';
  }

  // equifaxConsumerPaidDefaultsCommercialSingleObject
  try {
    const accountList = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:commercial-credit-file']?.['vs:accounts']?.['vs:account'];
    if (Array.isArray(accountList) && accountList.length === 1) {
      const firstDefault = accountList[0]?.['vs:defaults']?.['vs:default']?.[0];
      extraction.equifaxConsumerPaidDefaultsCommercialSingleObject = firstDefault?.['vs:status']?.['#text'] == 'Paid'
        ? firstDefault?.['vs:current-default']?.['vs:default-amount']?.['#text']
        : 0;
    } else {
      extraction.equifaxConsumerPaidDefaultsCommercialSingleObject = 0;
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting equifaxConsumerPaidDefaultsCommercialSingleObject: ' + errorMessage + ' ';
  }

  // ccrMortgageDataExists
  try {
    const accounts = (data?.['soapenv:Envelope'] as any)['soapenv:Body']['vs:response']['vs:product-data']['vs:enquiry-report']['vs:consumer-credit-file']['vs:accounts']['vs:account'];
    const accountList = Array.isArray(accounts) ? accounts : [accounts];
    extraction.ccrMortgageDataExists = accountList.filter((obj: any) => obj?.['vs:account-type']?.['#text']?.toLowerCase()?.includes('mortgage') && obj?.['vs:account-closed-date'] == null).length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting ccrMortgageDataExists: ' + errorMessage + ' ';
  }

  // directorRelatedEntityAdverse
  try {
    extraction.directorRelatedEntityAdverse = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:public-record-or-consumer-credit-information']?.
      ['vs:directorships']?.['vs:directorship'].filter((obj: any) => obj['vs:organisation']?.['vs:status']?.['@code']=='EXAD').length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting directorRelatedEntityAdverse: ' + errorMessage + ' ';
  }

  // bureauCheckResponseType
  try {
    extraction.bureauCheckResponseType = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['@response-type'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting bureauCheckResponseType: ' + errorMessage + ' ';
  }

  // individualBureauAge
  try {
    extraction.individualBureauAge = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block']?.map((obj: any) => obj['vs:characteristic'])?.
      flat(1).find((obj: any) => obj['@id'] === 'NA8902')?.['vs:value']['#text'];
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting individualBureauAge: ' + errorMessage + ' ';
  }

  // comprehensiveHighestRepaymentsStatus
  try {
    extraction.comprehensiveHighestRepaymentsStatus = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:consumer-credit-file']?.
      ['vs:accounts']?.['vs:account']?.map((obj: any) => obj['vs:repayment-history']['vs:payment'])?.flat(1)?.map((payment: any) => payment['vs:status'])?.reduce((a: any, b: any) => typeof b == 'number' ? Math.max(a, b) : a, 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting comprehensiveHighestRepaymentsStatus: ' + errorMessage + ' ';
  }

  // comprehensiveHighestRecentRepaymentsStatus
  try {
    extraction.comprehensiveHighestRecentRepaymentsStatus = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:enquiry-report']?.['vs:consumer-credit-file']?.
      ['vs:accounts']?.['vs:account']?.map((obj: any) => obj['vs:repayment-history']['vs:payment']?.slice(-3))?.flat(1)?.map((payment: any) => payment['vs:status']).reduce((a: any, b: any) => typeof b == 'number' ? Math.max(a, b) : a, 0);
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting comprehensiveHighestRecentRepaymentsStatus: ' + errorMessage + ' ';
  }

  // noBureauReport
  try {
    extraction.noBureauReport = (data?.['soapenv:Envelope'] as any)?.['soapenv:Body']?.['vs:response']?.['vs:general-messages']?.['vs:message']?.['@code'] ?? null;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting noBureauReport: ' + errorMessage + ' ';
  }

  // openAccounts
  try {
    const dataBlock = data?.['soapenv:Envelope']?.['soapenv:Body']?.['vs:response']?.['vs:product-data']?.['vs:summary-data']?.['vs:data-block'];
    if (Array.isArray(dataBlock)) {
      extraction.openAccounts = (dataBlock as any)?.map((obj: any) => obj?.['vs:characteristic']).flat(1).find((data: any) => data['@id'] === 'CX0005')?.['vs:value']['#text'];
    } else {
      extraction.openAccounts = (dataBlock?.['vs:characteristic'] as any).flat(1).find((data: any) => data['@id'] === 'CX0005')?.['vs:value']['#text'];
    }
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting openAccounts: ' + errorMessage + ' ';
  }

  return extraction;
}

export const extractEquifaxFraudCheckData = (data: EquifaxFraudCheckReportData): EquifaxFraudCheckExtraction => {
  let extraction: EquifaxFraudCheckExtraction = {
    error: '',
    fraudMatch: null,
  };

  // fraudMatch
  try {
    extraction.fraudMatch = data?.['responseData']['productData']['fraudCheckReport']['fraudCheckResults'].filter(obj => obj['fraudCheckResultDetails']['matchAssessment'] == 'POSSIBLE' || obj['fraudCheckResultDetails']['matchAssessment'] == 'SUSPICIOUS' || obj['fraudCheckResultDetails']['matchAssessment'] == 'HIGHLY_SUSPICIOUS').length;
  } catch (err) {
    const errorMessage = err instanceof Error ? err?.message : String(err).slice(0, 500);
    extraction.error += 'Error when extracting fraudMatch: ' + errorMessage + ' ';
  }
  
  return extraction;
}

// Generate a random 6-digit code
export const generateRandomSixDigitCode = () => {
  return Math.floor(100000 + Math.random() * 900000);
}

/**
 * Helper function to normalize name (lowercase, trim, remove extra spaces)
 */
export const normalizeName = (name: string): string => {
  return name?.toLowerCase().trim().replace(/\s+/g, ' ') || '';
};